/**
 * Tecno Restore — theme.js
 * JS vanilla, sin dependencias externas. Se carga con `defer`.
 */

document.addEventListener('DOMContentLoaded', function () {
  initMobileMenu();
  initSearchToggle();
  initPredictiveSearch();
  initStickyHeader();
  initCartDrawer();
  initQuantitySelectors();
  initQuickAdd();
  initScrollReveal();
  initProductGallery();
  initProductDescription();
  initShowcase();
  initProductRecommendations();
  initProductFormSubmit();
  initCartPageRemove();
  initCartPageQuantityValidation();
  initCheckoutGuard();
  initCollectionFilters();
  initVariantSelector();
  initCardTilt();
  initStickyBuyBar();
  initGalleryZoom();
  initAccountForms();
  initAddressCountrySelects();
  initRecentlyViewed();
  initPackBuilder();
  initBulkOrderSelector();
  initRestoreFlow();
  initCookiePreferencesLink();
  initAssistant();
  initPolicyHeadings();
});

/**
 * Selector de variantes (color/talla/capacidad...). Sin esto, elegir una
 * opción distinta no cambiaba qué variante se añadía al carrito: el
 * formulario seguía enviando siempre selected_or_first_available_variant,
 * así que un cliente podía seleccionar "256GB" y acabar comprando la
 * variante por defecto igualmente. Cada variante trae su HTML de precio y
 * de aviso de stock ya renderizados por Liquid (mismo snippet 'price' que
 * el resto del tema) para que el cambio sea idéntico a lo que Liquid
 * generaría — nada de reimplementar el formato de moneda en JS.
 */
function initVariantSelector() {
  var optionsWrapper = document.querySelector('[data-product-options]');
  var variantsScript = document.querySelector('[data-product-variants]');
  if (!optionsWrapper || !variantsScript) return;

  var variants;
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (error) {
    console.error(error);
    return;
  }

  var form = document.querySelector('[data-product-form]');
  var idInput = form && form.querySelector('[name="id"]');
  var priceBox = document.getElementById('ProductPrice');
  var priceStickyBox = document.getElementById('ProductPriceSticky');
  var lowStockBox = document.getElementById('ProductLowStock');
  var skuBox = document.getElementById('ProductSku');
  var submitButton = form && form.querySelector('.product__add-to-cart');

  function selectedOptionValues() {
    var fieldsets = optionsWrapper.querySelectorAll('fieldset');
    return Array.from(fieldsets).map(function (fieldset) {
      var checked = fieldset.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function findVariant() {
    var selected = selectedOptionValues();
    return variants.find(function (variant) {
      return (
        variant.options.length === selected.length &&
        variant.options.every(function (value, i) {
          return value === selected[i];
        })
      );
    });
  }

  function applyVariant(variant) {
    if (!variant) {
      // Combinación de opciones que no existe como variante real.
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = submitButton.getAttribute('data-unavailable-text') || submitButton.textContent;
      }
      return;
    }

    if (idInput) idInput.value = variant.id;
    if (priceBox) priceBox.innerHTML = variant.priceHtml;
    if (priceStickyBox) priceStickyBox.innerHTML = variant.priceHtml;
    if (lowStockBox) lowStockBox.innerHTML = variant.lowStockHtml || '';

    if (skuBox) {
      if (variant.sku) {
        skuBox.hidden = false;
        var skuValue = skuBox.querySelector('[data-sku-value]');
        if (skuValue) skuValue.textContent = variant.sku;
      } else {
        skuBox.hidden = true;
      }
    }

    if (submitButton) {
      submitButton.disabled = !variant.available;
      submitButton.textContent = variant.available
        ? submitButton.getAttribute('data-available-text') || submitButton.textContent
        : submitButton.getAttribute('data-sold-out-text') || submitButton.textContent;
    }

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }

  optionsWrapper.addEventListener('change', function (event) {
    if (event.target.matches('input[type="radio"]')) {
      applyVariant(findVariant());
    }
  });
}

/**
 * Filtros de colección: cada checkbox envía el formulario de facetas al
 * cambiar (mejora progresiva — sin JS, el <noscript><button> sigue
 * funcionando). En móvil, el panel de filtros se pliega bajo un botón.
 */
function initCollectionFilters() {
  var form = document.getElementById('CollectionFiltersForm');
  if (form) {
    form.addEventListener('change', function (event) {
      if (event.target.matches('[data-filter-checkbox], [data-filter-price]')) {
        form.submit();
      }
    });
  }

  var toggle = document.querySelector('[data-collection-filters-toggle]');
  var filters = document.querySelector('[data-collection-filters]');
  if (!toggle || !filters) return;

  toggle.addEventListener('click', function () {
    var isOpen = filters.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen);
  });
}

/**
 * Página de carrito (no el panel lateral): pone a 0 la cantidad de la fila
 * y envía el formulario nativo `{% form 'cart' %}`, reutilizando el mismo
 * mecanismo `updates[]` que ya usa el botón "Actualizar carrito" — sin
 * necesidad de Ajax en esta página.
 */
function initCartPageRemove() {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-page-remove]');
    if (!button) return;

    var row = button.closest('[data-cart-item-key]');
    var input = row && row.querySelector('[data-quantity-input]');
    if (!input) return;

    setRowQuantity(input, 0);
    button.closest('form').submit();
  });
}

/**
 * Intercepta el envío del formulario de compra de la PDP para añadir al
 * carrito por Ajax (sin recargar la página) y abrir el panel lateral,
 * igual que el "quick add" de las tarjetas de producto. Si algo falla
 * (variante agotada entre que se cargó la página y el envío, etc.), se
 * muestra el mensaje de error de Shopify en el propio formulario.
 */
function initProductFormSubmit() {
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var submitButton = form.querySelector('.product__add-to-cart');
  var errorBox = form.querySelector('[data-product-form-error]');

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var variantId = form.querySelector('[name="id"]').value;
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value || '1', 10) : 1;
    var minQuantity = quantityInput ? parseInt(quantityInput.getAttribute('min') || '1', 10) : 1;

    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    // Mínimo real de lote (custom.cantidad_minima_lote vía el atributo
    // min/data-min-error del input): si el cliente escribe una cantidad
    // menor a mano, se bloquea aquí, antes de llamar a /cart/add.js —
    // el atributo HTML min por sí solo no sirve porque el submit se
    // intercepta con preventDefault más arriba y nunca dispara la
    // validación nativa del navegador.
    if (quantityInput && quantity < minQuantity) {
      quantityInput.value = minQuantity;
      if (errorBox) {
        errorBox.textContent = quantityInput.getAttribute('data-min-error') || errorBox.getAttribute('data-generic-error') || '';
        errorBox.hidden = false;
      }
      return;
    }

    var originalButtonText = submitButton ? submitButton.textContent : '';
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = submitButton.getAttribute('data-loading-text') || originalButtonText;
    }

    addToCart(variantId, quantity)
      .then(function () {
        openCartDrawer();
      })
      .catch(function (error) {
        console.error(error);
        // El mensaje técnico de Shopify (p. ej. "Cannot find variant") no se
        // muestra nunca al cliente — solo el genérico traducido. El técnico
        // queda en consola para depurar.
        if (errorBox) {
          errorBox.textContent = errorBox.getAttribute('data-generic-error') || '';
          errorBox.hidden = false;
        }
      })
      .finally(function () {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalButtonText;
        }
      });
  });
}

/**
 * Ficha de producto: clic en una miniatura cambia la imagen principal.
 * Todas las imágenes ya están en el DOM (precargadas por el navegador con
 * loading="lazy" salvo la primera), así que el cambio es instantáneo, sin
 * parpadeo ni petición de red adicional.
 */
function initProductGallery() {
  var gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return;

  var main = gallery.querySelector('.product-gallery__main');
  var thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
  var images = Array.from(gallery.querySelectorAll('[data-gallery-image]'));
  if (!images.length) return;

  var counterCurrent = gallery.querySelector('[data-gallery-counter-current]');
  var prevButton = gallery.querySelector('[data-gallery-prev]');
  var nextButton = gallery.querySelector('[data-gallery-next]');

  function currentIndex() {
    var active = images.findIndex(function (img) {
      return img.classList.contains('is-active');
    });
    return active === -1 ? 0 : active;
  }

  function goTo(index) {
    var count = images.length;
    var target = ((index % count) + count) % count;

    images.forEach(function (img) {
      img.classList.toggle('is-active', Number(img.getAttribute('data-gallery-image')) === target);
    });
    thumbs.forEach(function (t) {
      var isActive = Number(t.getAttribute('data-gallery-thumb')) === target;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive);
    });
    if (counterCurrent) counterCurrent.textContent = target + 1;
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      goTo(Number(thumb.getAttribute('data-gallery-thumb')));
    });
  });

  // stopPropagation: los botones viven dentro de .product-gallery__main,
  // que también es el disparador del zoom — sin esto, cada clic en
  // anterior/siguiente abría el zoom a la vez que cambiaba de foto.
  if (prevButton) {
    prevButton.addEventListener('click', function (event) {
      event.stopPropagation();
      goTo(currentIndex() - 1);
    });
  }
  if (nextButton) {
    nextButton.addEventListener('click', function (event) {
      event.stopPropagation();
      goTo(currentIndex() + 1);
    });
  }

  if (main && images.length > 1) {
    main.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(currentIndex() - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(currentIndex() + 1); }
    });

    // Swipe táctil: umbral de 40px para no confundir un scroll vertical
    // normal de la página con una intención de cambiar de foto.
    var touchStartX = null;
    main.addEventListener('touchstart', function (event) {
      touchStartX = event.touches[0].clientX;
    }, { passive: true });
    main.addEventListener('touchend', function (event) {
      if (touchStartX === null) return;
      var deltaX = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(deltaX) > 40) {
        goTo(currentIndex() + (deltaX < 0 ? 1 : -1));
      }
      touchStartX = null;
    });
  }

  gallery.__galleryGoTo = goTo;
  gallery.__galleryCurrentIndex = currentIndex;
}

/**
 * Zoom de galería: en un negocio de tecnología reacondicionada, poder
 * inspeccionar de cerca el estado real del producto (marcas, desgaste) es
 * justo lo que más ayuda a decidir la compra — cursor:zoom-in sin zoom
 * real habría sido una promesa rota. Reutiliza las imágenes ya cargadas
 * de la galería principal (hasta 1300px), sin pedir ninguna más grande.
 */
function initGalleryZoom() {
  var trigger = document.querySelector('[data-gallery-zoom-trigger]');
  var overlay = document.querySelector('[data-gallery-zoom]');
  if (!trigger || !overlay) return;

  var zoomImage = overlay.querySelector('[data-gallery-zoom-image]');
  var prevButton = overlay.querySelector('[data-gallery-zoom-prev]');
  var nextButton = overlay.querySelector('[data-gallery-zoom-next]');
  var closeButtons = overlay.querySelectorAll('[data-gallery-zoom-close]');
  var mainImages = Array.from(document.querySelectorAll('[data-gallery-image]'));
  var thumbs = Array.from(document.querySelectorAll('[data-gallery-thumb]'));

  function currentIndex() {
    var active = mainImages.find(function (img) {
      return img.classList.contains('is-active');
    });
    return active ? Number(active.getAttribute('data-gallery-image')) : 0;
  }

  function showIndex(index) {
    var image = mainImages[index];
    if (!image) return;
    zoomImage.src = image.src;
    zoomImage.alt = image.alt;
    if (thumbs[index]) thumbs[index].click();
  }

  function open() {
    showIndex(currentIndex());
    overlay.hidden = false;
  }

  function close() {
    overlay.hidden = true;
  }

  trigger.addEventListener('click', open);
  trigger.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      open();
    }
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (event) {
    if (overlay.hidden) return;
    if (event.key === 'Escape') close();
    if (event.key === 'ArrowLeft' && prevButton) prevButton.click();
    if (event.key === 'ArrowRight' && nextButton) nextButton.click();
  });

  if (prevButton) {
    prevButton.addEventListener('click', function () {
      showIndex((currentIndex() - 1 + mainImages.length) % mainImages.length);
    });
  }
  if (nextButton) {
    nextButton.addEventListener('click', function () {
      showIndex((currentIndex() + 1) % mainImages.length);
    });
  }
}

/**
 * Recomendaciones de producto: se piden de forma diferida (solo cuando el
 * bloque entra en el viewport) contra el motor nativo de recomendaciones de
 * Shopify, para no gastar una petición de red en cada visita a la ficha si
 * el usuario no llega a bajar hasta ahí.
 */
function initProductRecommendations() {
  var wrappers = document.querySelectorAll('[data-recommendations-url]');
  if (!wrappers.length) return;

  // Compartido entre los dos bloques (complementa tu compra / también te
  // puede interesar): si el mismo producto ya salió en uno, no se repite
  // en el otro. Se ordena por posición en la página (querySelectorAll ya
  // devuelve los wrappers en orden de documento), así el bloque que está
  // más arriba —normalmente "complementa tu compra"— gana el hueco.
  var shownProductUrls = window.__pdpShownRecommendationUrls || (window.__pdpShownRecommendationUrls = new Set());

  wrappers.forEach(function (wrapper) {
    var targetId = wrapper.getAttribute('data-recommendations-target');
    var target = targetId ? document.getElementById(targetId) : null;
    var url = wrapper.getAttribute('data-recommendations-url');
    if (!target || !url) return;

    function fetchRecommendations() {
      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.getElementById(targetId);
          if (!fresh || fresh.textContent.trim() === '') return;

          var cards = fresh.querySelectorAll('.product-card');
          cards.forEach(function (card) {
            var link = card.querySelector('.product-card__link');
            var href = link ? link.getAttribute('href') : null;
            if (href && shownProductUrls.has(href)) {
              card.remove();
            } else if (href) {
              shownProductUrls.add(href);
            }
          });

          // Degradar con elegancia: si tras quitar duplicados ya no queda
          // ningún producto real que mostrar, el bloque entero desaparece
          // en vez de dejar un título "También te puede interesar" vacío.
          if (fresh.querySelectorAll('.product-card').length === 0) {
            target.innerHTML = '';
            return;
          }

          target.innerHTML = fresh.innerHTML;
        })
        .catch(function (error) {
          console.error(error);
        });
    }

    if (!('IntersectionObserver' in window)) {
      fetchRecommendations();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            fetchRecommendations();
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '400px 0px' }
    );

    observer.observe(wrapper);
  });
}

/**
 * Revela secciones marcadas con [data-reveal] al entrar en el viewport.
 * Una sola vez por elemento, discreto, y no bloquea el contenido si el
 * usuario tiene prefers-reduced-motion (ver base.css) o si el navegador
 * no soporta IntersectionObserver.
 */
function initScrollReveal() {
  var targets = document.querySelectorAll('[data-reveal]');
  if (!targets.length) return;

  if (!('IntersectionObserver' in window)) {
    targets.forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    // threshold 0: un umbral proporcional (antes 0.12) nunca se alcanza
    // cuando el bloque es más alto que la pantalla / umbral (p. ej. una
    // descripción larga en un portátil o con zoom) y el bloque se quedaba
    // invisible para siempre.
    { threshold: 0, rootMargin: '0px 0px -40px 0px' }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
}

/**
 * Restore Flow (Home): imagen sticky + barra de progreso + 6 pasos que se
 * activan según entran en el viewport — igual que la versión React de
 * Figma (IntersectionObserver + estado acumulado), sin frameworks.
 * Progresivo: el CSS por defecto ya muestra los 6 pasos completamente
 * legibles (opacity:1); solo cuando este script confirma que puede
 * observar el scroll añade [is-enhanced], que es lo que activa el
 * atenuado/resalte y el relleno de la barra de progreso. Si el navegador
 * no soporta IntersectionObserver, no se añade la clase y el contenido
 * se queda en su estado ya-legible por defecto — no hay estado roto.
 */
function initRestoreFlow() {
  var root = document.querySelector('[data-restore-flow]');
  if (!root || !('IntersectionObserver' in window)) return;

  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-restore-step]'));
  var segments = Array.prototype.slice.call(root.querySelectorAll('[data-restore-progress] span'));
  var images = Array.prototype.slice.call(root.querySelectorAll('[data-restore-image]'));
  var label = root.querySelector('[data-restore-label]');
  if (!steps.length) return;

  // Foco único ("spotlight"), no revelado acumulativo: solo el paso que
  // cruza el centro vertical del viewport queda activo (título en verde),
  // los demás vuelven a su peso normal — coincide con el comportamiento
  // verificado en el sistema aprobado (producto-repro.html / figma-home-repro.html),
  // no con un "una vez visto, se queda revelado".
  // Arranca en el paso 1: con -1 el primer aviso del observer (ningún paso
  // en el centro todavía) apagaba la foto del paso 1 y el panel se veía
  // negro hasta que el usuario hacía scroll hasta los pasos.
  var activeIndex = 0;

  function paint() {
    steps.forEach(function (step, i) {
      step.classList.toggle('is-active', i === activeIndex);
    });
    segments.forEach(function (seg, i) {
      seg.classList.toggle('is-active', i <= activeIndex);
    });
    images.forEach(function (img, i) {
      img.classList.toggle('is-active', i === activeIndex);
    });
    if (label && activeIndex > -1) {
      label.textContent = steps[activeIndex].getAttribute('data-restore-step-label') || label.textContent;
    }
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          activeIndex = Number(entry.target.getAttribute('data-restore-step'));
        }
      });
      paint();
    },
    { threshold: 0, rootMargin: '-45% 0px -45% 0px' }
  );

  steps.forEach(function (step) { observer.observe(step); });
  root.classList.add('is-enhanced');
}

/**
 * Reabre el panel nativo de preferencias de cookies de Shopify
 * (window.privacyBanner.showPreferences) desde el enlace permanente del
 * footer. No es un panel propio: reutiliza la misma API real que ya
 * gestiona el banner de consentimiento que Shopify inyecta — verificada
 * en vivo en la tienda antes de implementar esto. Si por lo que sea el
 * banner nativo no está activo (banner desactivado en el Admin, o no
 * aplica a la región del visitante), el botón simplemente no hace nada
 * en vez de fallar o mostrar un panel inventado.
 */
function initCookiePreferencesLink() {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-open-cookie-preferences]');
    if (!trigger) return;
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    }
  });
}

function initMobileMenu() {
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (!toggle || !menu) return;

  function setOpen(isOpen) {
    menu.classList.toggle('is-open', isOpen);
    toggle.setAttribute('aria-expanded', isOpen);
    menu.setAttribute('aria-hidden', !isOpen);
  }

  toggle.addEventListener('click', function () {
    setOpen(!menu.classList.contains('is-open'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && menu.classList.contains('is-open')) {
      setOpen(false);
      toggle.focus();
    }
  });
}

/**
 * Cualquier elemento con [data-search-toggle] abre el mismo overlay
 * (uno solo en la página, en el header) — el Home nuevo tiene su propio
 * disparador de búsqueda integrado en la escena, no solo el del header.
 */
function initSearchToggle() {
  var toggles = document.querySelectorAll('[data-search-toggle]');
  var bar = document.querySelector('[data-search-bar]');
  var closeButtons = document.querySelectorAll('[data-search-close]');
  if (!toggles.length || !bar) return;

  var input = bar.querySelector('input[type="search"]');
  var lastToggle = toggles[0];

  function open(trigger) {
    lastToggle = trigger || lastToggle;
    bar.removeAttribute('hidden');
    document.body.classList.add('search-is-open');
    toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
    // El foco espera al siguiente frame: hasta que se quita `hidden` el
    // input no es focusable, un focus() inmediato en el mismo tick no
    // hace nada en la mayoría de navegadores. La clase `is-open` espera
    // al mismo frame — es lo que activa la transición de entrada en CSS
    // (overlay entrando con profundidad, no un corte seco).
    requestAnimationFrame(function () {
      bar.classList.add('is-open');
      if (input) input.focus();
    });
  }

  function close() {
    bar.classList.remove('is-open');
    document.body.classList.remove('search-is-open');
    toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    if (lastToggle) lastToggle.focus();
    // `hidden` se aplica cuando termina la transición de salida, no al
    // instante — si no, el overlay desaparecería en seco antes de que la
    // animación llegue a reproducirse. El setTimeout es red de
    // seguridad: si transitionend no llega (o prefers-reduced-motion
    // colapsa la duración a ~0), el overlay igualmente queda oculto.
    var hidden = false;
    function hide() {
      if (hidden) return;
      hidden = true;
      bar.setAttribute('hidden', '');
      bar.removeEventListener('transitionend', hide);
    }
    bar.addEventListener('transitionend', hide);
    setTimeout(hide, 320);
  }

  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      if (bar.hasAttribute('hidden')) {
        open(toggle);
      } else {
        close();
      }
    });
  });

  closeButtons.forEach(function (btn) {
    btn.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !bar.hasAttribute('hidden')) {
      close();
    }
  });
}

/**
 * Buscador propio sobre la Predictive Search API nativa de Shopify
 * (/search/suggest.json) — sin apps, sin librerías. Foto real + precio
 * real + ahorro real (compare_at_price_max, ya viene en el endpoint) +
 * disponibilidad real en cada resultado. El estado del producto (grado,
 * origen) no está en este endpoint — no se inventa, se ve al entrar en
 * la ficha. Soporta teclado completo (↑↓ Enter Esc), cancela peticiones
 * en curso, y separa estados de carga/error/vacío/resultados.
 */
function initPredictiveSearch() {
  var input = document.querySelector('[data-predictive-search-input]');
  var resultsBox = document.querySelector('[data-predictive-search-results]');
  var hint = document.querySelector('[data-search-hint]');
  if (!input || !resultsBox) return;

  var debounceTimer;
  var currentController;
  var activeIndex = -1;
  var lastQuery = '';

  input.addEventListener('input', function () {
    var query = input.value.trim();
    clearTimeout(debounceTimer);
    activeIndex = -1;

    if (query.length < 2) {
      if (currentController) currentController.abort();
      resultsBox.setAttribute('hidden', '');
      resultsBox.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      if (hint) hint.hidden = false;
      return;
    }

    if (hint) hint.hidden = true;
    showLoading();

    debounceTimer = setTimeout(function () {
      fetchPredictiveSearch(query);
    }, 250);
  });

  input.addEventListener('keydown', function (event) {
    var items = resultsBox.querySelectorAll('.predictive-search-results__item');
    if (!items.length) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      activeIndex = Math.min(activeIndex + 1, items.length - 1);
      setActiveItem(items);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      activeIndex = Math.max(activeIndex - 1, -1);
      setActiveItem(items);
    } else if (event.key === 'Enter' && activeIndex > -1) {
      event.preventDefault();
      var href = items[activeIndex].getAttribute('href');
      if (href) window.location.href = href;
    }
  });

  function setActiveItem(items) {
    items.forEach(function (item, i) {
      item.classList.toggle('is-active', i === activeIndex);
      if (i === activeIndex) {
        item.scrollIntoView({ block: 'nearest' });
        input.setAttribute('aria-activedescendant', item.id);
      }
    });
    if (activeIndex === -1) input.removeAttribute('aria-activedescendant');
  }

  function showLoading() {
    var text = resultsBox.getAttribute('data-loading-text') || '';
    resultsBox.innerHTML = '<p class="predictive-search-results__status">' + escapeHtml(text) + '</p>';
    resultsBox.removeAttribute('hidden');
    input.setAttribute('aria-expanded', 'true');
  }

  function fetchPredictiveSearch(query) {
    if (currentController) currentController.abort();
    currentController = new AbortController();
    lastQuery = query;

    var url =
      '/search/suggest.json?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6';

    fetch(url, { signal: currentController.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('search request failed');
        return response.json();
      })
      .then(function (data) {
        renderPredictiveResults(data, query);
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') renderError();
      });
  }

  function renderError() {
    if (input.value.trim() !== lastQuery) return;
    var text = resultsBox.getAttribute('data-error-text') || '';
    resultsBox.innerHTML = '<p class="predictive-search-results__status predictive-search-results__status--error">' + escapeHtml(text) + '</p>';
    resultsBox.removeAttribute('hidden');
  }

  function renderPredictiveResults(data, query) {
    if (input.value.trim() !== query) return;
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];

    if (products.length === 0) {
      var emptyText = (resultsBox.getAttribute('data-no-results-text') || '').replace('""', '"' + escapeHtml(query) + '"');
      resultsBox.innerHTML = '<p class="predictive-search-results__status">' + emptyText + '</p>';
      resultsBox.removeAttribute('hidden');
      input.setAttribute('aria-expanded', 'true');
      return;
    }

    var soldOutText = resultsBox.getAttribute('data-sold-out-text') || '';

    var items = products
      .map(function (product, index) {
        var image = product.featured_image ? product.featured_image.url : product.image;
        var price = parseFloat(product.price);
        var compareAt = parseFloat(product.compare_at_price_max);
        var hasSavings = compareAt > price;
        // Truncar, no redondear: el resto del tema calcula el % de ahorro con
        // divided_by de Liquid (división entera, trunca hacia 0). Si aquí se
        // redondeara, el mismo producto podría mostrar un % distinto en el
        // buscador que en la ficha o el catálogo — mismo dato, dos cifras.
        var savingsPercent = hasSavings ? Math.floor(((compareAt - price) / compareAt) * 100) : 0;
        var itemId = 'PredictiveSearchItem' + index;

        return (
          '<a id="' + itemId + '" class="predictive-search-results__item" href="' + product.url + '">' +
            '<span class="predictive-search-results__media">' +
              (image ? '<img src="' + image + '&width=200" width="100" height="100" alt="" loading="lazy">' : '') +
              (hasSavings ? '<span class="predictive-search-results__savings">-' + savingsPercent + '%</span>' : '') +
            '</span>' +
            '<span class="predictive-search-results__info">' +
              '<span class="predictive-search-results__title">' + escapeHtml(product.title) + '</span>' +
              '<span class="predictive-search-results__meta">' +
                '<span class="predictive-search-results__price">' + formatMoney(product.price) + '</span>' +
                (hasSavings ? '<span class="predictive-search-results__compare-at">' + formatMoney(product.compare_at_price_max) + '</span>' : '') +
                (product.available === false ? '<span class="predictive-search-results__soldout">' + escapeHtml(soldOutText) + '</span>' : '') +
              '</span>' +
            '</span>' +
          '</a>'
        );
      })
      .join('');

    var viewAllLabel = resultsBox.getAttribute('data-view-all-text') || 'Ver todos los resultados';
    var viewAllUrl = '/search?q=' + encodeURIComponent(query);

    resultsBox.innerHTML =
      '<div class="predictive-search-results__list">' + items + '</div>' +
      '<a class="predictive-search-results__view-all" href="' + viewAllUrl + '">' + escapeHtml(viewAllLabel) + '</a>';
    resultsBox.removeAttribute('hidden');
    input.setAttribute('aria-expanded', 'true');
  }

  function formatMoney(value) {
    var num = parseFloat(value);
    if (isNaN(num)) return '';
    // Mismo formato que la tienda ("1.295,00 €"), no "€1295,00".
    return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(num);
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text || '';
    return div.innerHTML;
  }
}

/**
 * Añade sombra al header cuando hay scroll, para separarlo visualmente del
 * contenido sin perder altura fija (evita layout shift).
 */
function initStickyHeader() {
  var header = document.querySelector('[data-site-header]');
  if (!header) return;

  var ticking = false;

  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
        ticking = false;
      });
    },
    { passive: true }
  );
}

/**
 * Carrito: el panel lateral es una sección Liquid (sections/cart-drawer.liquid),
 * no un snippet estático. Tras cualquier mutación (añadir, cambiar cantidad,
 * eliminar) pedimos a Shopify que la vuelva a renderizar en servidor (Ajax
 * Cart API, parámetro `sections`) y sustituimos su HTML entero — así nunca
 * hay drift entre lo que ve el cliente y lo que Shopify considera el
 * carrito real, y no duplicamos el markup del item en JavaScript.
 *
 * Todos los listeners de clic/cambio dentro del carrito usan delegación en
 * `document`, no en los propios elementos: como el panel se sustituye por
 * completo en cada actualización, unos listeners atados a los nodos
 * originales dejarían de funcionar tras el primer cambio.
 */
function initCartDrawer() {
  var openTriggers = document.querySelectorAll('[data-cart-drawer-open]');
  openTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openCartDrawer();
    });
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-drawer-close]')) {
      closeCartDrawer();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCartDrawer();
  });
}

/**
 * "Envío gratis · llega jue 30–vie 31 oct" en el carrito lateral. Se
 * calcula en el navegador (no en Liquid: la sección se cachea y "now"
 * quedaría viejo) con la misma promesa de la tienda, 48–72 h en días
 * laborables (sábados y domingos no cuentan). Sin hora de corte: no hay
 * una definida. Si algo falla queda el texto genérico.
 */
function fillDeliveryWindow(root) {
  var el = (root || document).querySelector('[data-delivery-window][data-template]');
  if (!el) return;
  try {
    var addBusinessDays = function (date, days) {
      var d = new Date(date);
      while (days > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) days--;
      }
      return d;
    };
    var start = new Date();
    if (start.getDay() === 0 || start.getDay() === 6) start = addBusinessDays(start, 1);
    var lang = document.documentElement.lang || 'es';
    var fmt = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short' });
    var from = fmt.format(addBusinessDays(start, 2)).replace(/[.,]/g, '');
    var to = fmt.format(addBusinessDays(start, 3)).replace(/[.,]/g, '');
    el.textContent = el.getAttribute('data-template').replace('%F', from).replace('%T', to);
  } catch (error) {
    /* texto genérico de Liquid */
  }
}

function openCartDrawer() {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  fillDeliveryWindow(drawer);
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
}

function closeCartDrawer() {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
}

/**
 * Selectores de cantidad genéricos (+/-). Si el input pertenece al carrito
 * (data-cart-quantity-input), el cambio dispara una actualización real vía
 * Ajax Cart API. Si no (p. ej. el selector de cantidad de la PDP antes de
 * añadir al carrito), solo cambia el valor local — comportamiento sin red.
 */
/** parseInt de un valor de cantidad, nunca NaN/negativo (texto pegado, campo vacío, etc.) */
function safeQuantity(rawValue, fallback) {
  var parsed = parseInt(rawValue, 10);
  return Number.isNaN(parsed) ? fallback : Math.max(0, parsed);
}

/**
 * La página de carrito (main-cart.liquid) renderiza DOS inputs de
 * cantidad por línea con el mismo name="updates[key]" — uno visible en
 * móvil, otro en escritorio, ocultos por CSS según el ancho — porque
 * cada uno vive en su propio bloque de controles. Sin esto, cambiar la
 * cantidad en el input visible dejaba el otro con el valor antiguo del
 * servidor; al enviar el formulario, Shopify recibía dos valores
 * distintos para la misma línea y el mínimo de lote se podía saltar
 * enviando el duplicado no tocado. Se sincronizan siempre juntos.
 */
function setRowQuantity(input, value) {
  var row = input.closest('[data-cart-item-key]');
  var inputs = row ? row.querySelectorAll('[data-quantity-input]') : [input];
  inputs.forEach(function (el) {
    el.value = value;
  });
}

function showRowError(input, message) {
  var row = input.closest('[data-cart-item-key]');
  var errorEl = row && row.querySelector('[data-quantity-error]');
  if (!errorEl) return;
  errorEl.textContent = message || '';
  errorEl.hidden = !message;
}

function initQuantitySelectors() {
  document.addEventListener('click', function (event) {
    var removeBtn = event.target.closest('[data-cart-item-remove]');
    if (removeBtn) {
      updateCartItemQuantity(removeBtn.getAttribute('data-key'), 0);
      return;
    }

    var decreaseBtn = event.target.closest('[data-quantity-decrease]');
    var increaseBtn = event.target.closest('[data-quantity-increase]');
    if (!decreaseBtn && !increaseBtn) return;

    var selector = (decreaseBtn || increaseBtn).closest('[data-quantity-selector]');
    var input = selector && selector.querySelector('[data-quantity-input]');
    if (!input) return;

    var current = safeQuantity(input.value, 0);
    var min = safeQuantity(input.getAttribute('min'), 1);
    var wanted = current + (increaseBtn ? 1 : -1);
    var value = Math.max(min, wanted);
    setRowQuantity(input, value);
    if (decreaseBtn && wanted < min) {
      showRowError(input, input.getAttribute('data-min-error'));
    } else {
      showRowError(input, null);
    }
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-cart-quantity-input]')) return;
    var input = event.target;
    var value = safeQuantity(input.value, 0);
    var min = safeQuantity(input.getAttribute('min'), 0);

    // 0 sigue significando "eliminar la línea" (igual que antes): solo se
    // exige el mínimo cuando el cliente deja el lote en el carrito con
    // una cantidad positiva pero insuficiente.
    if (value > 0 && value < min) {
      value = min;
      showRowError(input, input.getAttribute('data-min-error'));
    } else {
      showRowError(input, null);
    }

    input.value = value;
    updateCartItemQuantity(input.getAttribute('data-key'), value);
  });
}

/**
 * Página de carrito (main-cart.liquid): a diferencia del panel lateral,
 * aquí no hay Ajax por línea — "Actualizar carrito" y "Finalizar compra"
 * son envíos nativos del formulario `{% form 'cart' %}`. El stepper +/-
 * ya respeta el mínimo (mismo listener de initQuantitySelectors), pero
 * escribir un número a mano en el campo no pasaba por ningún filtro:
 * esto valida al cambiar el campo (para dar feedback inmediato) y otra
 * vez al enviar el formulario como red de seguridad, bloqueando el
 * envío si queda algún lote por debajo de su mínimo real.
 */
function initCartPageQuantityValidation() {
  var form = document.querySelector('.cart-page__form');
  if (!form) return;

  function validateInput(input) {
    var min = safeQuantity(input.getAttribute('min'), 0);
    var value = safeQuantity(input.value, 0);

    if (value > 0 && value < min) {
      setRowQuantity(input, min);
      showRowError(input, input.getAttribute('data-min-error'));
      return false;
    }

    setRowQuantity(input, value);
    showRowError(input, null);
    return true;
  }

  form.addEventListener('change', function (event) {
    if (!event.target.matches('[data-quantity-input]')) return;
    validateInput(event.target);
  });

  form.addEventListener('submit', function (event) {
    var inputs = Array.prototype.slice.call(form.querySelectorAll('[data-quantity-input]'));
    var allValid = true;
    inputs.forEach(function (input) {
      if (!validateInput(input)) allValid = false;
    });
    if (!allValid) {
      event.preventDefault();
    }
  });
}

/**
 * Última red de seguridad antes de pasar a checkout: al hacer clic en
 * cualquier enlace "Finalizar compra" (el del panel lateral es un <a>
 * suelto, no un formulario, así que no pasa por initCartPageQuantityValidation
 * ni por el Ajax de updateCartItemQuantity si el cliente edita y navega
 * muy rápido), se relee el carrito real en el servidor (/cart.js, la
 * fuente de verdad, no el DOM) y se compara cada línea contra el mapa de
 * mínimos reales (data-lote-minimums, generado desde
 * custom.cantidad_minima_lote — nunca un número inventado en JS). Si
 * algo no cuadra, se cancela la navegación y se explica por qué en vez
 * de dejar avanzar a un cliente con un lote incompleto en el carrito.
 *
 * Límite conocido y real: esto cubre toda la interacción normal con
 * nuestra tienda (ficha, carrito lateral, página de carrito). No puede
 * impedir que alguien llame directamente a /cart/add.js o /checkout por
 * fuera del theme (curl, consola, JS deshabilitado) — eso exigiría una
 * Shopify Function de validación de carrito/checkout, que requiere plan
 * Shopify Plus (esta tienda es plan Basic, no disponible).
 */
function initCheckoutGuard() {
  var minimumsScript = document.querySelector('[data-lote-minimums]');
  if (!minimumsScript) return;

  var minimums;
  try {
    minimums = JSON.parse(minimumsScript.textContent || '{}');
  } catch (error) {
    minimums = {};
  }
  if (!Object.keys(minimums).length) return;

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-checkout-link]');
    if (!link) return;

    event.preventDefault();

    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var invalidItem = cart.items.find(function (item) {
          var rule = minimums[String(item.product_id)];
          return rule && item.quantity < rule.min;
        });

        if (!invalidItem) {
          window.location.href = link.href;
          return;
        }

        var rule = minimums[String(invalidItem.product_id)];
        var errorEl = document.querySelector('[data-checkout-error]');
        if (errorEl) {
          errorEl.textContent = invalidItem.product_title + ': ' + rule.message;
          errorEl.hidden = false;
        }
      })
      .catch(function () {
        // Si /cart.js falla por red, no bloquear la navegación: el
        // formulario de la página de carrito y el Ajax del panel lateral
        // ya validaron el mínimo en su momento.
        window.location.href = link.href;
      });
  });
}

function updateCartItemQuantity(key, quantity) {
  if (!key) return;

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer' }),
  })
    .then(function (response) {
      if (!response.ok) throw new Error('No se pudo actualizar el carrito');
      return response.json();
    })
    .then(function (cart) {
      renderCartDrawerSection(cart, true);
      updateCartCount(cart);
    })
    .catch(function (error) {
      console.error(error);
    });
}

function initQuickAdd() {
  // Delegado en document (no querySelectorAll+addEventListener por botón):
  // el carrito lateral sustituye su <aside id="CartDrawer"> entero por HTML
  // nuevo del servidor en cada cambio (ver renderCartDrawerSection), así
  // que los botones "Añadir" de "combina bien con" son nodos DOM nuevos en
  // cuanto el cliente añade, quita o cambia la cantidad de un producto. Un
  // listener atado directamente al botón original se perdía en ese
  // reemplazo y el botón quedaba muerto al clic. La delegación en document
  // sobrevive a cualquier sustitución de nodos.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-variant-id]');
    if (!button) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = button.dataset.quickAddOriginalText || button.textContent;
    button.dataset.quickAddOriginalText = originalText;

    button.disabled = true;
    button.textContent = button.getAttribute('data-loading-text') || originalText;
    addToCart(variantId, 1)
      .then(function () {
        button.textContent = originalText;
        openCartDrawer();
      })
      .catch(function (error) {
        console.error(error);
        // Sin panel de error disponible en la tarjeta: el propio botón
        // avisa un momento en vez de fallar en silencio.
        button.textContent = button.getAttribute('data-error-text') || originalText;
        button.classList.add('is-error');
        setTimeout(function () {
          button.textContent = originalText;
          button.classList.remove('is-error');
        }, 2500);
      })
      .finally(function () {
        button.disabled = false;
      });
  });
}

/**
 * Añade una línea al carrito y refresca el panel lateral. Devuelve una
 * promesa con el carrito completo (item_count, total_price, etc.) para que
 * quien llame pueda encadenar su propia UI (p. ej. abrir el drawer).
 */
function addToCart(variantId, quantity) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity || 1, sections: 'cart-drawer' }),
  })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (error) {
          throw new Error((error && error.description) || 'No se pudo añadir el producto');
        });
      }
      return response.json();
    })
    .then(function (result) {
      renderCartDrawerSection(result, true);
      return fetch('/cart.js').then(function (r) {
        return r.json();
      });
    })
    .then(function (cart) {
      updateCartCount(cart);
      return cart;
    });
}

/**
 * Sustituye el <aside id="CartDrawer"> completo por el HTML que acaba de
 * renderizar Shopify en servidor para esa misma sección, preservando si
 * estaba abierto (el fragmento recién renderizado siempre viene "cerrado",
 * porque el estado abierto/cerrado es puramente de cliente).
 */
function renderCartDrawerSection(result, keepOpenState) {
  var html = result && result.sections && result.sections['cart-drawer'];
  if (!html) return;

  var current = document.getElementById('CartDrawer');
  if (!current) return;

  var wasOpen = keepOpenState && current.classList.contains('is-open');
  var doc = new DOMParser().parseFromString(html, 'text/html');
  var fresh = doc.getElementById('CartDrawer');
  if (!fresh) return;

  current.replaceWith(fresh);
  fillDeliveryWindow(fresh);

  if (wasOpen) {
    fresh.classList.add('is-open');
    fresh.setAttribute('aria-hidden', 'false');
  }
}

/**
 * Añade varias líneas al carrito en una sola petición (usa el mismo
 * endpoint /cart/add.js que addToCart, pero con el payload {items: [...]}
 * que Shopify acepta para altas múltiples) y refresca el panel lateral,
 * igual que addToCart. La usa "Arma tu pack" (initPackBuilder) para que
 * el producto principal y los complementos marcados entren en el carrito
 * de una vez, no en N peticiones separadas.
 */
function addMultipleToCart(items) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items, sections: 'cart-drawer' }),
  })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (error) {
          throw new Error((error && error.description) || 'No se pudo añadir el pack');
        });
      }
      return response.json();
    })
    .then(function (result) {
      renderCartDrawerSection(result, true);
      return fetch('/cart.js').then(function (r) {
        return r.json();
      });
    })
    .then(function (cart) {
      updateCartCount(cart);
      return cart;
    });
}

/**
 * "Arma tu pack" (snippets/pack-builder.liquid): recalcula el total en vivo
 * al marcar/desmarcar complementos y añade todas las líneas seleccionadas
 * al carrito con un único clic. El formato de precio se construye a mano
 * (sin acceso al filtro `money` de Liquid desde JS) — asume EUR con coma
 * decimal, igual que el resto del tema.
 */
function initPackBuilder() {
  document.querySelectorAll('[data-pack-builder]').forEach(function (builder) {
    var checkboxes = builder.querySelectorAll('[data-pack-item]');
    var totalEl = builder.querySelector('[data-pack-total]');
    var savingsEl = builder.querySelector('[data-pack-savings]');
    var addButton = builder.querySelector('[data-pack-add]');
    if (!totalEl || !addButton) return;

    var mainPrice = parseInt(totalEl.getAttribute('data-main-price') || '0', 10);
    var mainSavings = savingsEl ? parseInt(savingsEl.getAttribute('data-main-savings') || '0', 10) : 0;
    var savingsTemplate = savingsEl ? savingsEl.getAttribute('data-savings-template') || '' : '';

    function formatCents(cents) {
      return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    }

    function updateTotal() {
      var total = mainPrice;
      var savings = mainSavings;
      checkboxes.forEach(function (checkbox) {
        if (checkbox.checked) {
          total += parseInt(checkbox.getAttribute('data-price') || '0', 10);
          savings += parseInt(checkbox.getAttribute('data-savings') || '0', 10);
        }
      });
      totalEl.textContent = formatCents(total);

      if (savingsEl) {
        if (savings > 0) {
          savingsEl.textContent = savingsTemplate.replace('__AMOUNT__', formatCents(savings));
          savingsEl.hidden = false;
        } else {
          savingsEl.hidden = true;
        }
      }
    }

    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', updateTotal);
    });
    updateTotal();

    addButton.addEventListener('click', function () {
      var items = [{ id: addButton.getAttribute('data-main-variant-id'), quantity: 1 }];
      checkboxes.forEach(function (checkbox) {
        if (checkbox.checked) {
          items.push({ id: checkbox.getAttribute('data-variant-id'), quantity: 1 });
        }
      });

      var originalText = addButton.textContent;
      addButton.disabled = true;
      addButton.textContent = addButton.getAttribute('data-loading-text') || originalText;

      addMultipleToCart(items)
        .then(function () {
          addButton.textContent = originalText;
          openCartDrawer();
        })
        .catch(function (error) {
          console.error(error);
          addButton.textContent = addButton.getAttribute('data-error-text') || originalText;
          setTimeout(function () {
            addButton.textContent = originalText;
          }, 2500);
        })
        .finally(function () {
          addButton.disabled = false;
        });
    });
  });
}

/**
 * Actualiza el contador del carrito en el header y da un pulso visual una
 * sola vez — es el único feedback fuera del propio drawer de que algo se
 * acaba de añadir. Nunca en loop, solo en el momento del cambio real.
 */
function updateCartCount(cart) {
  var cartCount = document.querySelector('[data-cart-count]');
  if (!cartCount) return;
  cartCount.textContent = cart.item_count;
  cartCount.classList.remove('is-updated');
  // Forzar reflow para poder reiniciar la animación si el usuario añade
  // dos productos seguidos antes de que termine el pulso anterior.
  void cartCount.offsetWidth;
  cartCount.classList.add('is-updated');
}

/**
 * Barra fija de "Añadir al carrito" en móvil/tablet: aparece solo cuando el
 * botón real de compra sale del viewport (el cliente ha bajado a leer
 * ficha técnica, specs, FAQ...), para no obligarle a volver a subir para
 * comprar. No duplica el formulario: simplemente dispara clic sobre el
 * botón real, que ya tiene todo el flujo de validación/carrito enganchado.
 */
function initStickyBuyBar() {
  var bar = document.querySelector('[data-product-sticky-bar]');
  var realButton = document.querySelector('.product__add-to-cart');
  var stickyButton = document.querySelector('[data-product-sticky-add]');
  if (!bar || !realButton || !stickyButton) return;

  stickyButton.addEventListener('click', function () {
    realButton.click();
  });

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    },
    { threshold: 0 }
  );
  observer.observe(realButton);
}

/**
 * Cuentas: alterna entre el formulario de login y el de recuperar
 * contraseña sin depender del servidor — Shopify redirige a esta misma
 * URL con #recover añadido tras enviar el formulario
 * recover_customer_password, así que basta con leer el hash al cargar
 * para saber cuál mostrar por defecto (p. ej. tras un error de recuperación).
 */
function initAccountForms() {
  var loginForm = document.querySelector('[data-login-form]');
  var recoverForm = document.querySelector('[data-recover-form]');
  if (!loginForm || !recoverForm) return;

  function showRecover() {
    loginForm.hidden = true;
    recoverForm.hidden = false;
  }

  function showLogin() {
    recoverForm.hidden = true;
    loginForm.hidden = false;
  }

  document.querySelectorAll('[data-show-recover]').forEach(function (button) {
    button.addEventListener('click', function () {
      window.location.hash = 'recover';
      showRecover();
    });
  });

  document.querySelectorAll('[data-hide-recover]').forEach(function (button) {
    button.addEventListener('click', function () {
      window.location.hash = '';
      showLogin();
    });
  });

  if (window.location.hash === '#recover') showRecover();
}

/**
 * Preselecciona el país guardado en los <select> generados por
 * all_country_option_tags en las direcciones de cliente — Shopify genera
 * las <option> pero no marca ninguna como seleccionada.
 */
function initAddressCountrySelects() {
  document.querySelectorAll('select[data-default-country]').forEach(function (select) {
    var value = select.getAttribute('data-default-country');
    if (value) select.value = value;
  });
}

/**
 * "Vistos recientemente": sin app ni backend, solo localStorage. Cada PDP
 * emite su propio resumen (id/url/título/imagen/precio/badge ya
 * renderizado por Liquid) en un <script type="application/json"> — así el
 * HTML del badge sale idéntico al del resto del sitio, sin reimplementar
 * el mapeo origen→color en JS. Cualquier página con un contenedor
 * [data-recently-viewed] lo rellena al vuelo, excluyendo el producto
 * actual si estamos en su propia ficha.
 */
function initRecentlyViewed() {
  var STORAGE_KEY = 'tecnorestore:recently-viewed';
  var MAX_ITEMS = 8;

  function getStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (error) {
      return [];
    }
  }

  function setStored(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      // Almacenamiento no disponible (modo privado, cuota llena...): la
      // función degrada a "no recordar nada", nunca debe romper la PDP.
    }
  }

  function escapeText(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  var currentScript = document.querySelector('[data-current-product]');
  var current = null;
  if (currentScript) {
    try {
      current = JSON.parse(currentScript.textContent);
    } catch (error) {
      current = null;
    }
  }

  if (current) {
    var items = getStored().filter(function (item) {
      return item.id !== current.id;
    });
    items.unshift(current);
    setStored(items.slice(0, MAX_ITEMS));
  }

  var mounts = document.querySelectorAll('[data-recently-viewed]');
  if (!mounts.length) return;

  var toShow = getStored().filter(function (item) {
    return !current || item.id !== current.id;
  });
  if (!toShow.length) return;

  mounts.forEach(function (mount) {
    var list = mount.querySelector('[data-recently-viewed-list]');
    if (!list) return;

    // Sin imagen guardada (product.featured_image estaba vacío cuando se
    // visitó esa ficha): mismo placeholder que product-card.liquid, nunca
    // un hueco vacío ni una foto de otro producto.
    var noImageText = mount.getAttribute('data-no-image-text') || '';
    var placeholderIcon =
      '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="10" r="1.5"/><path d="m4 17 5-5 3.5 3.5L16 12l4 4"/></svg>';

    list.innerHTML = toShow
      .slice(0, 4)
      .map(function (item) {
        return (
          '<a class="recently-viewed__item" href="' + item.url + '">' +
          '<span class="recently-viewed__image">' +
          (item.image
            ? '<img src="' + item.image + '" alt="" width="150" height="150" loading="lazy">'
            : '<span class="recently-viewed__placeholder">' + placeholderIcon + '<span>' + escapeText(noImageText) + '</span></span>') +
          '</span>' +
          '<span class="recently-viewed__info">' +
          (item.badgeHtml || '') +
          '<span class="recently-viewed__title">' + escapeText(item.title) + '</span>' +
          '<span class="recently-viewed__price">' + escapeText(item.price) +
          (item.savingsPercent > 0 ? ' <span class="price__savings">-' + item.savingsPercent + '%</span>' : '') +
          '</span>' +
          '</span>' +
          '</a>'
        );
      })
      .join('');
    mount.hidden = false;
  });
}

/**
 * Inclinación 3D sutil al pasar el ratón por un grupo reducido y deliberado
 * de tarjetas (categorías de home). Solo transform (composited, sin
 * relayout) y solo en dispositivos con puntero fino — en touch no se
 * activa nunca, porque una inclinación que no responde al dedo se siente
 * rota, no elegante.
 */
function initCardTilt() {
  var cards = document.querySelectorAll('[data-tilt]');
  if (!cards.length) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var MAX_DEG = 7;

  cards.forEach(function (card) {
    var raf = null;

    card.addEventListener('pointermove', function (event) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var rect = card.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.transform =
          'perspective(700px) rotateX(' + (-y * MAX_DEG).toFixed(2) + 'deg) rotateY(' +
          (x * MAX_DEG).toFixed(2) + 'deg) translateY(-3px)';
      });
    });

    card.addEventListener('pointerleave', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = null;
      card.style.transform = '';
    });
  });
}

/**
 * Compra individual / compra por lote (bulk-order-selector.liquid). El
 * bloque no decide nada por sí mismo: solo sincroniza la cantidad elegida
 * con el input real del formulario de compra (data-quantity-input) para
 * que "Añadir al carrito" siga siendo el único botón que compra, en modo
 * individual o en modo lote. En modo lote se oculta el selector +/- normal
 * (la cantidad la fija el desplegable de lote, no el usuario a mano) y se
 * restaura al volver a "Compra individual".
 */
function initBulkOrderSelector() {
  document.querySelectorAll('[data-bulk-order]').forEach(function (bulkOrder) {
    var form = bulkOrder.closest('form');
    if (!form) return;

    var quantityInput = form.querySelector('[data-quantity-input]');
    var quantitySelector = form.querySelector('[data-quantity-selector]');
    var modeInputs = bulkOrder.querySelectorAll('[data-bulk-mode-input]');
    var quantityWrap = bulkOrder.querySelector('[data-bulk-quantity-wrap]');
    var quantitySelect = bulkOrder.querySelector('[data-bulk-quantity-select]');
    if (!quantityInput || !modeInputs.length) return;

    function applyMode() {
      var mode = bulkOrder.querySelector('[data-bulk-mode-input]:checked');
      var isBulk = mode && mode.value === 'lote';

      if (quantityWrap) quantityWrap.hidden = !isBulk;
      if (quantitySelector) quantitySelector.hidden = isBulk;

      if (isBulk && quantitySelect) {
        quantityInput.value = quantitySelect.value;
      } else {
        quantityInput.value = 1;
      }
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    modeInputs.forEach(function (input) {
      input.addEventListener('change', applyMode);
    });
    if (quantitySelect) {
      quantitySelect.addEventListener('change', applyMode);
    }

    applyMode();
  });
}

/**
 * Asistente TecnoRestore — motor de intención por reglas (NO un LLM real).
 * Toda la "inteligencia" es coincidencia de patrones sobre texto en
 * español contra dos fuentes de datos 100% reales, ambas generadas por
 * Liquid en el servidor (ver snippets/assistant-catalog-data.liquid y el
 * bloque de cadenas de assistant.liquid): nunca se inventa un precio, un
 * estado, una garantía ni una condición — si el patrón no encaja con
 * ninguna regla real, se responde explícitamente que no se sabe.
 */
function initAssistant() {
  var root = document.querySelector('[data-assistant]');
  if (!root) return;

  var toggle = root.querySelector('[data-assistant-toggle]');
  var closeBtn = root.querySelector('[data-assistant-close]');
  var overlay = root.querySelector('[data-assistant-overlay]');
  var thread = root.querySelector('[data-assistant-thread]');
  var suggestionsBox = root.querySelector('[data-assistant-suggestions]');
  var form = root.querySelector('[data-assistant-form]');
  var input = root.querySelector('[data-assistant-input]');
  var currentProductHandle = root.getAttribute('data-assistant-current-product') || null;

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  var catalog = readJSON('trx-assistant-catalog');
  var strings = readJSON('trx-assistant-strings');
  // Sin datos reales no hay asistente — nunca se degrada a respuestas
  // inventadas si el snapshot de Liquid no cargó.
  if (!catalog || !strings || !toggle || !thread || !form || !input) return;

  var hasWelcomed = false;
  // Estado de conversación mínimo — un único valor, no un historial
  // completo: solo recuerda si el asistente acaba de hacer UNA pregunta
  // de seguimiento (presupuesto) y está esperando la respuesta. Nada se
  // guarda más allá de la sesión de navegación (se pierde al recargar).
  var pendingClarification = null;

  function openPanel() {
    root.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (!hasWelcomed) {
      addBotMessage(strings.welcome);
      renderSuggestions(strings.suggestions);
      hasWelcomed = true;
    }
    setTimeout(function () {
      input.focus();
    }, 300);
  }

  function closePanel() {
    root.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', function () {
    if (root.classList.contains('is-open')) {
      closePanel();
    } else {
      openPanel();
    }
  });
  if (closeBtn) closeBtn.addEventListener('click', closePanel);
  if (overlay) overlay.addEventListener('click', closePanel);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.classList.contains('is-open')) closePanel();
  });

  // El disparador es position:fixed en la esquina inferior derecha. Auditoría
  // CRO 2026-09-19: la comprobación de solape original solo protegía UN
  // bloque (.trx__hero-feature-info, el precio/CTA del Hero de Home) pero en
  // vivo se veía tapando también el CTA "Ver producto" del propio Hero, el
  // texto de Restore Flow y el CTA final "Explorar catálogo" — cualquier
  // bloque real, no solo el Hero. Generalizado: cualquier elemento marcado
  // con data-assistant-avoid en cualquier página se protege igual, con la
  // misma lógica de fade+desplazamiento solo mientras coincide de verdad.
  // Sin bloques marcados en la página, la comprobación no encuentra nada y
  // el disparador se queda siempre visible, como antes.
  // Tras 600 px de scroll el disparador pasa a botón cuadrado "?" (ver
  // .assistant__trigger.is-compact en base.css): la pestaña con texto
  // tapaba tarjetas de producto en escritorio.
  (function compactOnScroll() {
    var ticking = false;
    function update() {
      ticking = false;
      toggle.classList.toggle('is-compact', window.scrollY > 600);
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
  })();

  (function avoidOverlapWithProtectedContent() {
    var protectedEls = document.querySelectorAll('[data-assistant-avoid]');
    if (!protectedEls.length) return;
    var ticking = false;

    function check() {
      ticking = false;
      var t = toggle.getBoundingClientRect();
      var overlaps = false;
      for (var i = 0; i < protectedEls.length; i++) {
        var p = protectedEls[i].getBoundingClientRect();
        if (p.width === 0 && p.height === 0) continue;
        if (!(t.right < p.left || t.left > p.right || t.bottom < p.top || t.top > p.bottom)) {
          overlaps = true;
          break;
        }
      }
      toggle.classList.toggle('is-yielding', overlaps);
    }

    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    check();
  })();

  function scrollToBottom() {
    thread.scrollTop = thread.scrollHeight;
  }

  function escapeHTML(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function addUserMessage(text) {
    var el = document.createElement('div');
    el.className = 'assistant__msg assistant__msg--user';
    var eyebrow = document.createElement('span');
    eyebrow.className = 'assistant__msg-eyebrow';
    eyebrow.textContent = strings.you;
    var p = document.createElement('p');
    p.className = 'assistant__msg-text';
    p.textContent = text;
    el.appendChild(eyebrow);
    el.appendChild(p);
    thread.appendChild(el);
    scrollToBottom();
  }

  // `html` se construye SIEMPRE aquí mismo a partir de cadenas ya
  // traducidas (strings.*, reales, nunca input de usuario) más marcado
  // <a> propio — no hace falta escaparlo. Los datos que sí vienen del
  // catálogo real (título, estado) se escapan dentro de buildProductCard.
  function addBotMessage(html, products) {
    var el = document.createElement('div');
    el.className = 'assistant__msg assistant__msg--bot';
    var eyebrow = document.createElement('span');
    eyebrow.className = 'assistant__msg-eyebrow';
    eyebrow.textContent = catalog.shop_name || 'TecnoRestore';
    var p = document.createElement('p');
    p.className = 'assistant__msg-text';
    p.innerHTML = html;
    el.appendChild(eyebrow);
    el.appendChild(p);
    if (products && products.length) {
      var list = document.createElement('div');
      list.className = 'assistant__products';
      products.forEach(function (product) {
        list.appendChild(buildProductCard(product));
      });
      el.appendChild(list);
    }
    thread.appendChild(el);
    scrollToBottom();
  }

  function formatPrice(value) {
    try {
      return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(value);
    } catch (e) {
      return value + ' €';
    }
  }

  function buildProductCard(product) {
    var a = document.createElement('a');
    a.className = 'assistant__product';
    a.href = product.url;
    var imageHTML = product.image
      ? '<img src="' + escapeHTML(product.image) + '" alt="" loading="lazy">'
      : '';
    a.innerHTML =
      '<div class="assistant__product-image">' + imageHTML + '</div>' +
      '<div class="assistant__product-info">' +
        '<span class="assistant__product-state">' + escapeHTML(product.state) + '</span>' +
        '<span class="assistant__product-title">' + escapeHTML(product.title) + '</span>' +
      '</div>' +
      '<div class="assistant__product-price-wrap">' +
        '<span class="assistant__product-price">' + formatPrice(product.price) + '</span>' +
        '<span class="assistant__product-cta">' + escapeHTML(strings.viewProduct) + '</span>' +
      '</div>';
    return a;
  }

  // Cada sugerencia es {id, label} — el id decide una respuesta con
  // comportamiento garantizado (ver resolveSuggestionAction), en vez de
  // simular que el cliente ha escrito la etiqueta y pasarla por el motor
  // de texto libre. Botones como "Buscar producto" no encajan con ningún
  // patrón de resolveIntent (no es una pregunta, es un menú) — tratarlos
  // como texto libre los mandaba directos al "no lo sé", que es
  // justo lo que un botón de menú nunca debería hacer.
  function renderSuggestions(list) {
    suggestionsBox.innerHTML = '';
    (list || []).forEach(function (item) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'assistant__suggestion';
      btn.textContent = item.label;
      btn.addEventListener('click', function () {
        handleSuggestionClick(item);
      });
      suggestionsBox.appendChild(btn);
    });
  }

  function handleSuggestionClick(item) {
    if (item.id === 'lotes') {
      handleUserInput(item.label + ' (lotes al por mayor)');
      return;
    }
    addUserMessage(item.label);
    clearSuggestions();
    var response = resolveSuggestionAction(item.id);
    addBotMessage(response.html, response.products);
    renderSuggestions(response.suggestions || strings.suggestions);
  }

  function resolveSuggestionAction(id) {
    if (id === 'search') {
      setTimeout(function () {
        input.focus();
      }, 250);
      return { html: strings.searchGuidance };
    }
    if (id === 'budget') {
      pendingClarification = 'budget';
      return { html: strings.askBudget };
    }
    if (id === 'warranty') {
      return { html: strings.warrantyGeneric + '<br><br>' + strings.returns };
    }
    if (id === 'lotes-old') {
      var lotes = filterProducts({ lotesOnly: true });
      if (lotes.length) {
        return { html: strings.lotesIntro, products: lotes.slice(0, 4) };
      }
      return {
        html: strings.lotesEmpty + ' <a href="' + escapeHTML(catalog.pro_url) + '">Tecno Restore PRO</a>.'
      };
    }
    return { html: strings.fallback + ' <a href="' + escapeHTML(strings.contactUrl) + '">' + escapeHTML(strings.fallbackContactLink) + '</a>.' };
  }

  function clearSuggestions() {
    suggestionsBox.innerHTML = '';
  }

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var value = input.value.trim();
    if (!value) return;
    input.value = '';
    handleUserInput(value);
  });

  var brain = createAssistantBrain({ catalog: catalog, currentHandle: currentProductHandle, payments: strings.payments || [] });

  // Cerebro nuevo: búsqueda real en todo el catálogo + preguntas frecuentes.
  // El presupuesto pedido con el botón "Por presupuesto" se interpreta igual:
  // "300" o "hasta 300 €" refinan la última búsqueda o buscan de todo.
  function handleUserInput(text) {
    addUserMessage(text);
    clearSuggestions();
    var typing = document.createElement('div');
    typing.className = 'assistant__msg assistant__msg--bot assistant__msg--typing';
    typing.innerHTML = '<span class="assistant__typing" aria-label="Buscando"><i></i><i></i><i></i></span>';
    thread.appendChild(typing);
    scrollToBottom();
    var query = text;
    if (pendingClarification === 'budget') {
      pendingClarification = null;
      if (/^\s*\d{2,5}\s*(€|euros?)?\s*$/i.test(text)) query = 'hasta ' + text.replace(/[^\d]/g, '') + ' euros';
    }
    brain.answer(query).then(function (response) {
      typing.remove();
      addBotMessage(response.html, response.products);
      if (response.after) {
        var lastMsg = thread.lastElementChild;
        var extra = document.createElement('p');
        extra.className = 'assistant__msg-text assistant__msg-after';
        extra.innerHTML = response.after;
        lastMsg.appendChild(extra);
        scrollToBottom();
      }
      renderSuggestions(response.suggestions || strings.suggestions);
    }).catch(function () {
      typing.remove();
      addBotMessage(strings.fallback + ' <a href="' + escapeHTML(strings.contactUrl) + '">' + escapeHTML(strings.fallbackContactLink) + '</a>.');
      renderSuggestions(strings.suggestions);
    });
  }

  // Respuesta a "¿qué presupuesto tienes?" — cualquier número en el
  // siguiente mensaje se interpreta como el precio máximo, sin exigir
  // "menos de" (a diferencia de matchPriceCeiling): el contexto de la
  // pregunta ya deja claro qué significa ese número. Si no hay ningún
  // número, no se insiste — se trata el mensaje como uno nuevo, para no
  // dejar al cliente atascado si cambia de tema.
  function resolvePendingBudget(rawText) {
    var text = normalize(rawText);
    pendingClarification = null;
    var m = text.match(/(\d{1,5})(?:[.,]\d{1,2})?/);
    if (m) {
      var maxPrice = parseFloat(m[1].replace(',', '.'));
      var results = filterProducts({ maxPrice: maxPrice, excludeLotes: true });
      return productResultsResponse(results, catalog.all_products_url);
    }
    return resolveIntent(rawText);
  }

  // ---------------------------------------------------------------------
  // Motor de intención — todo el "entendimiento" vive aquí. Coincidencia
  // de patrones sobre texto normalizado (minúsculas, sin acentos), no un
  // modelo de lenguaje. Cada rama devuelve texto real (strings.*) o
  // productos reales (catalog.products) — ninguna rama inventa nada; la
  // rama final explícita dice que no lo sabe.
  // ---------------------------------------------------------------------

  function normalize(str) {
    return String(str)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();
  }

  var categoryDefs = (catalog.categories || []).map(function (cat) {
    return {
      handle: cat.handle,
      label: cat.label,
      url: cat.url,
      count: cat.count,
      keywords: (cat.keywords || '').split('|').map(normalize).filter(Boolean)
    };
  });

  function matchCategory(text) {
    for (var i = 0; i < categoryDefs.length; i++) {
      var cat = categoryDefs[i];
      for (var j = 0; j < cat.keywords.length; j++) {
        if (text.indexOf(cat.keywords[j]) > -1) return cat;
      }
    }
    return null;
  }

  // Auditoría 2026-09-20: "¿Qué tenéis de Xiaomi?" no encontraba nada
  // porque no existía ninguna comprobación de marca — matchCategory solo
  // conoce las 9 categorías, nunca el fabricante. La pregunta caía en la
  // rama genérica "que teneis" (ver resolveIntent) antes de llegar a
  // ningún intento real de búsqueda, así que respondía con el recuento
  // total del catálogo en vez de productos reales de esa marca. Fuente
  // 100% real: marcas ya presentes en catalog.products (p.vendor), sin
  // inventar ninguna lista. \b...\b evita falsos positivos de marcas
  // cortas (ej. "HP") coincidiendo dentro de otra palabra.
  var vendorDefs = [];
  (function buildVendorDefs() {
    var seen = {};
    (catalog.products || []).forEach(function (p) {
      var v = p.vendor;
      if (!v || seen[v]) return;
      seen[v] = true;
      vendorDefs.push(v);
    });
    vendorDefs.sort(function (a, b) {
      return b.length - a.length;
    });
  })();

  function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function matchVendor(text) {
    for (var i = 0; i < vendorDefs.length; i++) {
      var normVendor = normalize(vendorDefs[i]);
      if (!normVendor) continue;
      var re = new RegExp('\\b' + escapeRegExp(normVendor) + '\\b');
      if (re.test(text)) return vendorDefs[i];
    }
    return null;
  }

  function matchPriceCeiling(text) {
    var hasCeilingWord = /(menos de|por debajo|hasta|maximo|no mas de)/.test(text);
    if (!hasCeilingWord) return null;
    var m = text.match(/(\d{1,5})(?:[.,]\d{1,2})?\s*(?:€|eur|euros?)?/);
    if (!m) return null;
    return parseFloat(m[1].replace(',', '.'));
  }

  function matchUnitsQuantity(text) {
    var m = text.match(/(\d{2,6})\s*unidades?/);
    return m ? parseInt(m[1], 10) : null;
  }

  function filterProducts(opts) {
    return (catalog.products || [])
      .filter(function (p) {
        if (!p.available) return false;
        if (opts.category && p.collections.indexOf(opts.category) === -1) return false;
        if (opts.vendor && p.vendor !== opts.vendor) return false;
        if (opts.maxPrice != null && p.price > opts.maxPrice) return false;
        if (opts.lotesOnly && !p.is_lote) return false;
        if (opts.excludeLotes && p.is_lote) return false;
        return true;
      })
      .sort(function (a, b) {
        return a.price - b.price;
      });
  }

  function searchByTitleKeywords(text) {
    var words = text.split(/\s+/).filter(function (w) {
      return w.length > 3;
    });
    if (!words.length) return [];
    return (catalog.products || [])
      .filter(function (p) {
        return p.available;
      })
      .map(function (p) {
        var title = normalize(p.title);
        var score = 0;
        words.forEach(function (w) {
          if (title.indexOf(w) > -1) score++;
        });
        return { product: p, score: score };
      })
      .filter(function (x) {
        return x.score > 0;
      })
      .sort(function (a, b) {
        return b.score - a.score;
      })
      .map(function (x) {
        return x.product;
      });
  }

  function findCurrentProduct() {
    if (!currentProductHandle) return null;
    var matches = (catalog.products || []).filter(function (p) {
      return p.handle === currentProductHandle;
    });
    return matches.length ? matches[0] : null;
  }

  function productResultsResponse(products, emptyLinkUrl) {
    if (products.length) {
      return { html: strings.resultsIntro, products: products.slice(0, 4) };
    }
    return {
      html: strings.resultsEmpty + ' <a href="' + escapeHTML(emptyLinkUrl) + '">' + escapeHTML(strings.viewAllLink) + '</a>'
    };
  }

  // Anclado (^...$): solo dispara si el mensaje ES un saludo, no si
  // simplemente empieza por "hola" seguido de una pregunta real — así
  // "Hola" cae aquí, pero "Hola, busco auriculares" sigue resolviéndose
  // como búsqueda de producto más abajo, no como saludo.
  var GREETING_RE = /^(hola+|hey|hi|buenas|buenos dias|buenas tardes|buenas noches|que tal|ola)[\s!¡.,]*$/;

  function resolveIntent(rawText) {
    var text = normalize(rawText);

    // Saludo — un asistente comercial no puede responder "no lo sé" a
    // "Hola". Responde con la misma bienvenida real (qué puede hacer) y
    // las mismas sugerencias rápidas que al abrir el panel por primera
    // vez, para que la primera impresión sea siempre la misma.
    if (GREETING_RE.test(text)) {
      return { html: strings.welcome, suggestions: strings.suggestions };
    }

    // Compra por lotes / volumen — antes que categoría, porque "50
    // unidades de auriculares" debe leerse como intención de volumen,
    // no como una búsqueda de producto individual.
    if (/\blotes?\b/.test(text) || /por mayor/.test(text) || matchUnitsQuantity(text) != null) {
      var lotes = filterProducts({ lotesOnly: true });
      if (lotes.length) {
        return { html: strings.lotesIntro, products: lotes.slice(0, 4) };
      }
      return {
        html: strings.lotesEmpty + ' <a href="' + escapeHTML(catalog.pro_url) + '">Tecno Restore PRO</a>.'
      };
    }

    // Tecno Restore PRO
    if (/\bpro\b/.test(text) || /profesional/.test(text) || /compra recurrente/.test(text)) {
      return {
        html: strings.proPitch + ' <a href="' + escapeHTML(catalog.pro_url) + '">' + escapeHTML(strings.viewAllLink) + '</a>'
      };
    }

    // Diferencia entre orígenes/estados reales
    if (
      (/diferencia/.test(text) || /que significa/.test(text)) &&
      /(reacondicionado|devolucion|excedente|liquidacion|nuevo)/.test(text)
    ) {
      return { html: strings.diffStates };
    }

    // Garantía
    if (/garantia/.test(text)) {
      var currentForWarranty = findCurrentProduct();
      if (currentForWarranty) {
        // Un lote no revisado no "tiene X de garantía" con normalidad —
        // decirlo así sonaría a que X es una cifra de confianza como
        // cualquier otra. Misma condición real (is_unreviewed_lote) que
        // ya usa warranty-info.liquid en la ficha, nunca "12 meses" aquí.
        if (currentForWarranty.is_unreviewed_lote) {
          return { html: strings.warrantyUnreviewedLote };
        }
        // Los lotes (revisados incluidos) no tienen un estado real vía
        // origin-badge (no aplica un origen único a un lote variado), así
        // que %%STATE%% llega vacío — sin este condicional, la frase
        // quedaba con un paréntesis vacío: "1 año de garantía ()".
        // Sin cifra de garantía (para reparar/piezas, despiece sin comprobar,
        // lote B2B): la frase "tiene X de garantía" no aplica — se usa el
        // texto completo de condiciones que ya muestra la ficha.
        if (currentForWarranty.warranty_has_figure === false && currentForWarranty.warranty_text) {
          return { html: escapeHTML(currentForWarranty.warranty_text) };
        }
        var warrantyMsg = strings.warrantyProduct.replace('%%WARRANTY%%', currentForWarranty.warranty);
        if (currentForWarranty.state) {
          warrantyMsg = warrantyMsg.replace('%%STATE%%', currentForWarranty.state);
        } else {
          warrantyMsg = warrantyMsg.replace(' (%%STATE%%)', '');
        }
        return { html: escapeHTML(warrantyMsg) };
      }
      if (/este producto|este articulo|esto tiene/.test(text)) {
        return { html: strings.currentProductMissing };
      }
      return { html: strings.warrantyGeneric };
    }

    // Devoluciones / desistimiento
    if (/devol/.test(text) || /puedo devolver/.test(text) || /cambiar el producto/.test(text)) {
      return { html: strings.returns };
    }

    // Envíos
    if (/envio/.test(text) || /entrega/.test(text) || /\btarda\b/.test(text)) {
      return { html: strings.shipping };
    }

    // Cómo funciona TecnoRestore / proceso de revisión
    if (/como funciona/.test(text) || /revision tecnica/.test(text) || /47 puntos/.test(text)) {
      return { html: strings.howItWorks };
    }

    // Estado del producto actualmente abierto (solo tiene sentido en PDP)
    if (/(es nuevo|es reacondicionado|es de segunda mano|que estado tiene|en que estado)/.test(text)) {
      var cp = findCurrentProduct();
      if (cp) {
        return { html: escapeHTML(cp.title + ': ' + cp.state + '.') };
      }
      return { html: strings.currentProductMissing };
    }

    // Búsqueda real por categoría, marca y/o presupuesto — el núcleo de "compra"
    var category = matchCategory(text);
    var maxPrice = matchPriceCeiling(text);
    var vendor = matchVendor(text);

    // Intención comercial real pero sin nada todavía con qué filtrar
    // ("quiero un regalo", "algo barato", "no sé qué comprar"): en vez de
    // caer directo al "no lo sé", se hace UNA pregunta de seguimiento útil
    // (presupuesto) — no una IA general, solo el caso comercial más
    // habitual y más fácil de resolver con los datos reales que ya hay.
    // Si el mensaje YA trae categoría, marca o precio (p. ej. "un regalo de
    // gaming por 30€"), no hace falta preguntar: sigue directo a la
    // búsqueda real de abajo.
    if (!category && !vendor && maxPrice == null) {
      if (/regalo|regalar|sorpresa/.test(text) || /barato|economic|low cost/.test(text) || /no se que comprar|no se qué|ayudame a elegir|no tengo ni idea|no tengo claro/.test(text)) {
        pendingClarification = 'budget';
        return { html: strings.askBudget };
      }
    }

    // Auditoría 2026-09-20: esta comprobación tiene que ir ANTES de "que
    // teneis" — "¿Qué tenéis de Xiaomi?" contiene literalmente "que
    // teneis" y antes caía siempre en la rama genérica de más abajo
    // (recuento total del catálogo), sin llegar nunca a intentar la
    // búsqueda real por marca aunque matchVendor ya la hubiera detectado.
    if (category || vendor || maxPrice != null) {
      var results = filterProducts({
        category: category ? category.handle : null,
        vendor: vendor,
        maxPrice: maxPrice,
        excludeLotes: true
      });
      return productResultsResponse(results, catalog.all_products_url);
    }

    // Catálogo general / "qué tenéis ahora mismo"
    if (/que teneis|que productos|que hay disponible|catalogo completo/.test(text)) {
      var overview = strings.catalogOverview.replace('%%COUNT%%', catalog.products_count);
      return {
        html: escapeHTML(overview) + ' <a href="' + escapeHTML(catalog.all_products_url) + '">' + escapeHTML(strings.viewAllLink) + '</a>'
      };
    }

    // Último intento antes de rendirse: búsqueda libre por palabras del
    // título real, solo si el mensaje suena a búsqueda de producto.
    if (/busco|quiero|necesito|teneis|hay algun|algo de/.test(text)) {
      var keywordResults = searchByTitleKeywords(text);
      if (keywordResults.length) {
        return productResultsResponse(keywordResults, catalog.all_products_url);
      }
    }

    // No se ha podido responder con datos reales — se dice explícitamente,
    // no se inventa una respuesta plausible.
    return {
      html: strings.fallback + ' <a href="' + escapeHTML(strings.contactUrl) + '">' + escapeHTML(strings.fallbackContactLink) + '</a>.'
    };
  }
}

/**
 * Políticas legales (/policies/*): el texto llega del Admin como párrafos
 * planos, con los apartados escritos como "1. DERECHO DE DESISTIMIENTO".
 * Se marcan esos párrafos (número + texto en mayúsculas) para darles
 * estilo de título y se enlazan desde un índice al principio. Solo
 * presentación: el contenido legal no se toca.
 */
function initPolicyHeadings() {
  var body = document.querySelector('.shopify-policy__body');
  if (!body) return;
  var heads = [];
  body.querySelectorAll('p').forEach(function (p) {
    var text = p.textContent.trim();
    if (/^\d{1,2}\.\s+[^a-záéíóúñ]{3,}$/.test(text)) {
      p.classList.add('policy-heading');
      p.id = 'apartado-' + (heads.length + 1);
      heads.push(p);
    }
  });
  if (heads.length < 3) return;
  var nav = document.createElement('nav');
  nav.className = 'policy-toc';
  nav.setAttribute('aria-label', 'Índice');
  nav.innerHTML = '<ol>' + heads.map(function (h) {
    var label = h.textContent.trim().replace(/^\d{1,2}\.\s+/, '');
    label = label.charAt(0) + label.slice(1).toLowerCase();
    return '<li><a href="#' + h.id + '">' + label.replace(/[<>&]/g, '') + '</a></li>';
  }).join('') + '</ol>';
  body.insertBefore(nav, body.firstElementChild);
}



/**
 * Descripciones de ficha legibles (24-10-2026).
 * 1) Las listas de especificaciones del proveedor ("-Tipo de pantalla: AMOLED",
 *    una por párrafo o separadas por <br>) se convierten en una tabla compacta
 *    con sus subtítulos ("Diseño", "Características"…). Con más de 10 filas se
 *    muestran 8 y un botón "Ver todas las especificaciones".
 * 2) Si la descripción sigue siendo muy alta, se recorta con un degradado y
 *    "Leer la descripción completa".
 * Sin JS, el texto original se ve igual que antes (nada se oculta en Liquid).
 */
function initProductDescription() {
  var root = document.querySelector('.product__description');
  if (!root) return;

  var SPEC = /^[-–•·*]\s*([^:]{2,70}?)\s*:\s*(.+)$/;

  function segments(block) {
    // Texto de un bloque partido por <br>.
    var html = block.innerHTML.replace(/<br\s*\/?>/gi, '\n');
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent.split('\n').map(function (t) { return t.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
  }

  function isHeading(t) {
    return t.length <= 40 && t.indexOf(':') === -1 && !/[.!?]$/.test(t) && !/^[-–•·*]/.test(t);
  }

  function classify(block) {
    var segs = segments(block);
    if (!segs.length) return { kind: 'empty' };
    var rows = [];
    var specs = 0;
    for (var i = 0; i < segs.length; i++) {
      var m = segs[i].match(SPEC);
      if (m) { rows.push({ k: m[1], v: m[2] }); specs++; }
      else if (isHeading(segs[i])) rows.push({ g: segs[i] });
      else return { kind: 'other' };
    }
    return specs ? { kind: 'spec', rows: rows } : { kind: 'head', rows: rows };
  }

  // Bloques de texto "hoja": p, li, td, th, div sin bloques dentro.
  var blocks = Array.prototype.filter.call(
    root.querySelectorAll('p, li, td, th, div'),
    function (el) { return !el.querySelector('p, li, td, th, div, table, ul, ol') && !el.closest('.tr-section'); }
  );

  var runs = [];
  var current = null;
  blocks.forEach(function (el) {
    var c = classify(el);
    if (c.kind === 'spec' || (c.kind === 'head' && current)) {
      if (!current) current = { nodes: [], rows: [], specs: 0 };
      current.nodes.push(el);
      current.rows = current.rows.concat(c.rows);
      current.specs += c.rows.filter(function (r) { return r.k; }).length;
    } else if (c.kind === 'head') {
      current = { nodes: [el], rows: c.rows.slice(), specs: 0 };
    } else if (c.kind === 'empty' && current) {
      current.nodes.push(el);
    } else {
      if (current) runs.push(current);
      current = null;
    }
  });
  if (current) runs.push(current);

  runs.forEach(function (run) {
    if (run.specs < 4) return;
    // Quitar subtítulos sueltos al final del bloque (pertenecen a lo siguiente).
    while (run.rows.length && !run.rows[run.rows.length - 1].k) run.rows.pop();
    var wrap = document.createElement('div');
    wrap.className = 'tr-specs';
    var table = document.createElement('table');
    table.className = 'tr-specs__table';
    var tbody = document.createElement('tbody');
    var dataRows = 0;
    run.rows.forEach(function (r) {
      var tr = document.createElement('tr');
      if (r.g) {
        tr.className = 'tr-specs__group';
        var th = document.createElement('th');
        th.colSpan = 2;
        th.textContent = r.g;
        tr.appendChild(th);
      } else {
        dataRows++;
        if (dataRows > 8) tr.className = 'tr-specs__extra';
        var k = document.createElement('th');
        k.scope = 'row';
        k.textContent = r.k;
        var v = document.createElement('td');
        v.textContent = r.v;
        tr.appendChild(k);
        tr.appendChild(v);
      }
      tbody.appendChild(tr);
    });
    table.appendChild(tbody);
    wrap.appendChild(table);
    if (dataRows > 10) {
      wrap.classList.add('is-collapsed');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'tr-specs__toggle';
      btn.textContent = 'Ver todas las especificaciones (' + dataRows + ')';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-collapsed') === false;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Ver menos' : 'Ver todas las especificaciones (' + dataRows + ')';
      });
      wrap.appendChild(btn);
    }
    var first = run.nodes[0];
    // Si el primer nodo es una celda de tabla, la tabla compacta va dentro de ella.
    if (first.tagName === 'TD' || first.tagName === 'TH') {
      first.innerHTML = '';
      first.appendChild(wrap);
      run.nodes.slice(1).forEach(function (n) { n.remove(); });
    } else {
      first.parentNode.insertBefore(wrap, first);
      run.nodes.forEach(function (n) { n.remove(); });
    }
  });

  // Párrafos vacíos que quedan sueltos.
  Array.prototype.forEach.call(root.querySelectorAll('p'), function (p) {
    if (!p.textContent.trim() && !p.querySelector('img, iframe, video')) p.remove();
  });

  // Recorte de descripciones muy altas.
  var LIMIT = 900;
  if (root.scrollHeight > LIMIT + 200) {
    root.classList.add('is-clamped');
    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'product__description-more';
    more.textContent = 'Leer la descripción completa';
    more.setAttribute('aria-expanded', 'false');
    more.addEventListener('click', function () {
      var clamped = root.classList.toggle('is-clamped');
      more.setAttribute('aria-expanded', clamped ? 'false' : 'true');
      more.textContent = clamped ? 'Leer la descripción completa' : 'Ver menos';
      if (clamped) root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
    root.parentNode.insertBefore(more, root.nextSibling);
  }
}


/**
 * Escaparate 3D de la portada (24-10-2026): tarjetas en perspectiva que se
 * deslizan con el dedo, el ratón, las flechas o el teclado; la del centro se
 * inclina siguiendo el puntero; pasa sola cada 5 s (se pausa al interactuar
 * y con prefers-reduced-motion). Sin JS se ve solo la primera tarjeta.
 */
function initShowcase() {
  var root = document.querySelector('[data-showcase]');
  if (!root) return;
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-showcase-slide]'));
  var n = slides.length;
  if (n < 2) return;
  var stage = root.querySelector('[data-showcase-stage]');
  var dotsWrap = root.querySelector('[data-showcase-dots]');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var current = 0;
  var timer = null;
  var resumeTimer = null;

  slides.forEach(function () { dotsWrap.appendChild(document.createElement('span')); });
  var dots = dotsWrap.querySelectorAll('span');

  function render() {
    var half = Math.floor(n / 2);
    slides.forEach(function (el, i) {
      var pos = ((i - current + n + half) % n) - half;
      var abs = Math.abs(pos);
      el.style.setProperty('--pos', pos);
      el.style.setProperty('--abs', abs);
      el.classList.toggle('is-active', pos === 0);
      if (abs > 2) el.setAttribute('data-far', ''); else el.removeAttribute('data-far');
      el.setAttribute('tabindex', pos === 0 ? '0' : '-1');
      el.setAttribute('aria-hidden', pos === 0 ? 'false' : 'true');
      if (pos !== 0) {
        var card = el.querySelector('.trx-show__card');
        card.style.removeProperty('--tx');
        card.style.removeProperty('--ty');
      }
    });
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
  }

  function go(i) {
    current = (i + n) % n;
    render();
  }

  function stop() {
    clearInterval(timer);
    timer = null;
    clearTimeout(resumeTimer);
    if (!reduce) resumeTimer = setTimeout(start, 9000);
  }

  function start() {
    if (reduce || timer) return;
    timer = setInterval(function () { go(current + 1); }, 5000);
  }

  root.querySelector('[data-showcase-prev]').addEventListener('click', function () { stop(); go(current - 1); });
  root.querySelector('[data-showcase-next]').addEventListener('click', function () { stop(); go(current + 1); });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { stop(); go(current - 1); }
    if (e.key === 'ArrowRight') { stop(); go(current + 1); }
  });

  // Arrastrar / deslizar.
  var startX = null;
  var moved = false;
  stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
  stage.addEventListener('pointerdown', function (e) { startX = e.clientX; moved = false; });
  window.addEventListener('pointermove', function (e) {
    if (startX !== null && Math.abs(e.clientX - startX) > 8) moved = true;
  });
  window.addEventListener('pointerup', function (e) {
    if (startX === null) return;
    var dx = e.clientX - startX;
    startX = null;
    if (Math.abs(dx) > 40) { stop(); go(current + (dx < 0 ? 1 : -1)); }
  });
  stage.addEventListener('pointercancel', function () { startX = null; });

  // Clic en una tarjeta lateral: la trae al centro en vez de abrirla.
  slides.forEach(function (el, i) {
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); moved = false; return; }
      if (!el.classList.contains('is-active')) { e.preventDefault(); stop(); go(i); }
    });
  });

  // Inclinación 3D de la tarjeta central siguiendo el puntero.
  if (!reduce) {
    stage.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var active = slides[current].querySelector('.trx-show__card');
      var r = active.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      if (Math.abs(x) > 0.9 || Math.abs(y) > 0.9) return;
      active.style.setProperty('--tx', (x * 16).toFixed(2) + 'deg');
      active.style.setProperty('--ty', (-y * 12).toFixed(2) + 'deg');
      active.style.setProperty('--gx', ((x + 0.5) * 100).toFixed(0) + '%');
      active.style.setProperty('--gy', ((y + 0.5) * 100).toFixed(0) + '%');
    });
    stage.addEventListener('pointerleave', function () {
      var active = slides[current].querySelector('.trx-show__card');
      active.style.removeProperty('--tx');
      active.style.removeProperty('--ty');
    });
  }

  root.addEventListener('mouseenter', function () { clearInterval(timer); timer = null; });
  root.addEventListener('mouseleave', function () { start(); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) { clearInterval(timer); timer = null; } else start(); });

  root.classList.add('is-ready');
  render();
  start();
}

/**
 * Cerebro del asistente (24-10-2026). Sustituye al buscador sobre el
 * snapshot de ~140 productos: busca en TODO el catálogo con la búsqueda real
 * de la tienda (/search?…&view=assistant, JSON con estado y garantía reales),
 * entiende uso (jugar, estudiar, trabajar, regalo…), presupuesto, categoría y
 * marca, descarta piezas y equipos incompletos, recuerda la última búsqueda
 * para refinarla ("más barato", "menos de 200") y responde las dudas de
 * compra (envío, devolución, garantía, estados, pago, factura, contacto,
 * pedidos, lotes…) con los datos reales de la tienda. Nunca responde "no sé":
 * siempre ofrece resultados, una búsqueda o el contacto directo.
 */
function createAssistantBrain(cfg) {
  var C = cfg.catalog || {};
  var EMAIL = 'tecnorestore1@gmail.com';
  var PHONE = '663 67 03 81';
  var HOURS = 'de lunes a viernes, de 9:00 a 18:00';
  var last = null; // última búsqueda de producto, para refinar

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9ñ€.,\s-]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function link(url, text) { return '<a href="' + esc(url) + '">' + esc(text) + '</a>'; }
  function money(n) { try { return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(n); } catch (e) { return n + ' €'; } }
  function has(t, re) { return re.test(t); }

  var contactLine = 'Escríbenos a <strong>' + EMAIL + '</strong> o llámanos al <strong>' + PHONE + '</strong> (' + HOURS + ') y te ayudamos en persona.';

  // ---------- Categorías: palabra del cliente → tipo de producto + términos de búsqueda ----------
  var CATS = [
    { re: /\b(movil|moviles|telefono|telefonos|smartphone|iphone|celular|galaxy|redmi|xiaomi mi)\b/, type: 'Móviles', q: 'móvil', terms: ['móvil', 'smartphone'], label: 'móviles' },
    { re: /\b(portatil|portatiles|laptop|notebook|chromebook|thinkpad|elitebook|latitude|probook|macbook|ultrabook)\b/, type: 'Portátiles', q: 'portátil', terms: ['portátil', 'portatil'], label: 'portátiles' },
    { re: /\b(sobremesa|torre|pc|ordenador de mesa|mini pc|minipc|all in one|aio|thinkcentre|optiplex|equipo)\b/, type: 'Informática y Periféricos', q: 'sobremesa', terms: ['sobremesa', 'mini pc', 'ordenador', 'pc'], label: 'ordenadores de sobremesa', computer: true },
    { re: /\b(tablet|tablets|ipad|tableta)\b/, type: 'Tablets', q: 'tablet', terms: ['tablet', 'ipad'], label: 'tablets' },
    { re: /\b(monitor|monitores|pantalla para (el )?(pc|ordenador))\b/, type: 'Informática y Periféricos', q: 'monitor', terms: ['monitor'], label: 'monitores', only: /^monitor/i },
    { re: /\b(impresora|impresoras|multifuncion|imprimir|escaner)\b/, type: 'Impresión', q: 'impresora', terms: ['impresora', 'multifunción'], label: 'impresoras', only: /impresora|multifunci/i },
    { re: /\b(toner|cartucho|cartuchos|tinta)\b/, type: 'Impresión', q: 'tóner', terms: ['tóner', 'cartucho', 'tinta'], label: 'consumibles de impresión' },
    { re: /\b(auricular|auriculares|cascos|headset|earbuds|airpods)\b/, type: 'Audio y sonido', q: 'auriculares', terms: ['auriculares'], label: 'auriculares', only: /auricular/i },
    { re: /\b(altavoz|altavoces|barra de sonido|soundbar|equipo de musica|radio)\b/, type: 'Audio y sonido', q: 'altavoz', terms: ['altavoz', 'altavoces'], label: 'altavoces', only: /altavo|barra de sonido|radio/i },
    { re: /\b(reloj|smartwatch|pulsera|band|wearable)\b/, type: 'Wearables', q: 'reloj', terms: ['reloj inteligente', 'smartwatch', 'pulsera de actividad'], label: 'relojes y pulseras' },
    { re: /\b(tele|tv|television|televisor|proyector|proyectores|peliculas|pelis|series|cine|netflix|salon|smart tv|chromecast|android tv)\b/, type: 'Imagen y TV', q: 'proyector', terms: ['proyector', 'televisor', 'smart tv', 'android tv'], label: 'proyectores y TV', only: /proyector|televisor|smart tv|android tv|\btv box|chromecast|fire tv/i },
    { re: /\b(camara|camaras|polaroid|instantanea|webcam)\b/, type: null, q: 'cámara', terms: ['cámara', 'polaroid', 'webcam'], label: 'cámaras', only: /c[aá]mara|polaroid|webcam/i },
    { re: /\b(consola|consolas|mando|mandos|volante|volantes|gamepad|joystick|ps5|ps4|xbox|nintendo|switch)\b/, type: 'Gaming y consolas', q: 'mando', terms: ['consola', 'mando', 'volante'], label: 'productos de gaming' },
    { re: /\b(teclado|teclados|raton|ratones|mouse)\b/, type: 'Informática y Periféricos', q: 'teclado', terms: ['teclado', 'ratón'], label: 'teclados y ratones', only: /teclado|rat[oó]n|combo/i },
    { re: /\b(router|wifi|mesh|repetidor|switch de red|red|conectividad|access point|punto de acceso)\b/, type: 'Redes y Conectividad', q: 'router', terms: ['router', 'mesh', 'repetidor', 'wifi'], label: 'productos de red' },
    { re: /\b(aspirador|aspiradora|robot aspirador|fregona)\b/, type: null, q: 'aspirador', terms: ['robot aspirador', 'aspirador', 'aspiradora'], label: 'robots aspiradores', only: /aspirador/i },
    { re: /\b(domotica|bombilla|enchufe inteligente|camara de vigilancia|hogar inteligente|robot educativo|robotica)\b/, type: 'Robots y hogar inteligente', q: 'inteligente', terms: ['inteligente', 'robot', 'wifi'], label: 'productos de hogar inteligente' },
    { re: /\b(disco|ssd|hdd|ram|memoria|grafica|tarjeta grafica|procesador|placa base|fuente de alimentacion|componente|componentes)\b/, type: 'Componentes', q: 'ssd', terms: ['ssd', 'disco', 'memoria ram'], label: 'componentes' },
    { re: /\b(cargador|cargadores|power ?bank|bateria externa)\b/, type: 'Cargadores', q: 'cargador', terms: ['cargador', 'power bank'], label: 'cargadores' },
    { re: /\b(funda|fundas|carcasa|carcasas|protector)\b/, type: 'Fundas y Carcasas', q: 'funda', terms: ['funda', 'carcasa'], label: 'fundas' },
    { re: /\b(cable|cables|adaptador|hub|dock|docking)\b/, type: null, q: 'cable', terms: ['cable', 'adaptador', 'hub'], label: 'cables y adaptadores' },
    { re: /\b(electrodomestico|freidora|cafetera|horno|batidora|microondas|plancha)\b/, type: 'Pequeño electrodoméstico', q: 'freidora', terms: ['freidora', 'cafetera', 'horno', 'batidora'], label: 'electrodomésticos' }
  ];

  // ---------- Usos: qué quiere hacer el cliente ----------
  var USES = [
    { re: /\b(jugar|juego|juegos|gaming|gamer|roblox|fortnite|minecraft|valorant|lol|league|gta|steam|warzone|fifa|fc ?2\d)\b/, id: 'gaming',
      advice: 'Para Roblox, Minecraft o Fortnite no hace falta un equipo caro: con un Intel Core i5 (o Ryzen 5), 8 GB de RAM y disco SSD van fluidos. Si quiere jugar a juegos más exigentes, mejor 16 GB de RAM.' },
    { re: /\b(estudiar|estudios|clase|clases|colegio|instituto|universidad|uni|deberes|carrera|estudiante)\b/, id: 'study',
      advice: 'Para estudiar (apuntes, Office, Teams, navegar) va sobrado un portátil con i3/i5 o Ryzen, 8 GB de RAM y SSD. Mejor de 14″ o menos si lo va a llevar encima.' },
    { re: /\b(trabajar|trabajo|oficina|teletrabajo|empresa|reuniones|zoom|teams|excel|contabilidad)\b/, id: 'work',
      advice: 'Para trabajar, los portátiles de gama empresa (ThinkPad, Latitude, EliteBook, ProBook) son los más duraderos: buen teclado, Windows Pro y piezas robustas.' },
    { re: /\b(regalo|regalar|nino|nina|ninos|hijo|hija|sobrino|infantil|cumpleanos|navidad|reyes)\b/, id: 'gift',
      advice: 'Ideas que suelen acertar: auriculares, relojes inteligentes, cámaras instantáneas Polaroid, robots educativos o un mando o volante si juega.' },
    { re: /\b(editar|edicion|video|diseno|photoshop|premiere|render|programar|programacion)\b/, id: 'pro',
      advice: 'Para editar vídeo, diseñar o programar con soltura conviene un i7 / Ryzen 7 con 16 GB de RAM o más y SSD de 512 GB.' },
    { re: /\b(correr|deporte|gimnasio|gym|running|nadar|ciclismo|bici)\b/, id: 'sport',
      advice: 'Para deporte, una pulsera o reloj con GPS y pulsómetro, y unos auriculares inalámbricos resistentes al sudor.' },
    { re: /\b(mayor|mayores|abuelo|abuela|personas mayores)\b/, id: 'senior',
      advice: 'Para personas mayores funcionan muy bien los móviles con teclas grandes y botón SOS, o una tablet sencilla.' }
  ];

  var JUNK = /despiece|para piezas|para reparar|sin ram|sin disco|sin hd|sin s\.?o|barebone|solo peana|solo funda|solo dongle|solo mando|repuesto|recambio|placa base (original )?completa|kit de montaje|disipador|webcam original para|solo es /i;
  var NOT_PHYSICAL = /servicio|extensi[oó]n (de )?garant|software|licencia|suscripci|vmware|care ?pack|soporte t[eé]cnico|recuperaci[oó]n de datos/i;
  var WEAK_PC = /celeron|atom|pentium|\b4 ?gb\b|ddr3|w7|windows 7|e-?mmc|32 ?gb/i;

  function parseBudget(t) {
    var out = {};
    var m = t.match(/(menos de|hasta|maximo|max|por debajo de|no mas de|tope de|tope|presupuesto de|presupuesto|como mucho|unos|sobre|alrededor de)\s*(\d{2,5})/);
    if (m) out.max = parseFloat(m[2]) * (/(unos|sobre|alrededor)/.test(m[1]) ? 1.15 : 1);
    var m2 = t.match(/(mas de|desde|minimo|a partir de|por encima de)\s*(\d{2,5})/);
    if (m2) out.min = parseFloat(m2[2]);
    var m3 = t.match(/(\d{2,5})\s*(€|euros|eur|e)\b/);
    if (!out.max && m3 && !m2) out.max = parseFloat(m3[1]);
    var m4 = t.match(/entre\s*(\d{2,5})\s*y\s*(\d{2,5})/);
    if (m4) { out.min = parseFloat(m4[1]); out.max = parseFloat(m4[2]); }
    if (/\b(barato|barata|baratos|economico|economica|low cost|lo mas barato|poco dinero|ajustado)\b/.test(t)) out.cheap = true;
    if (/\b(mejor|potente|top|gama alta|el mejor|lo mejor|potencia)\b/.test(t)) out.best = true;
    return out;
  }

  var STOP = ' sirve sirven servira vale valdria parecido parecida similar similares alternativa alternativas igual como este esta ese esa a al algo alguna alguno algun ante busco buscar busca buscando como con cual cuales de del el en es esta este esto estoy hay hola la las le lo los me mi mis necesito necesita para pero por porque puedo que quiero quisiera quiere recomiendas recomendais recomendar se sea ser si sin sobre su sus tal te teneis tienes tiene tu un una uno unos unas y ya yo mas menos hasta euros eur barato barata bueno buena bonito bonita mejor algun cosa cosas tipo favor gracias dime ver ensename enseñame mira ofreces vendeis venden teneis ';
  var GENERIC = ' movil moviles telefono telefonos smartphone portatil portatiles laptop ordenador ordenadores pc sobremesa equipo tablet tablets tableta monitor monitores impresora impresoras auricular auriculares cascos altavoz altavoces reloj relojes pulsera camara camaras consola consolas mando mandos teclado teclados raton ratones router aspirador aspiradora cargador cargadores funda fundas cable cables producto productos jugar juego juegos gaming gamer estudiar estudios trabajar trabajo regalo regalar nino nina ninos anos ano casa correr deporte lote lotes revender mayor pulgadas pulgada roblox fortnite minecraft valorant lol league gta steam warzone fifa clase clases colegio instituto universidad uni oficina teletrabajo empresa editar video diseno programar gimnasio running mayores abuelo abuela inalambrico inalambricos inalambrica bluetooth wifi para familia hijo hija sobrino cumpleanos navidad reyes peliculas pelis series cine netflix salon ver ';
  function keywords(t) {
    var out = [];
    var ws = t.split(' ');
    ws.forEach(function (w, i) {
      var next = ws[i + 1] || '';
      if (/^\d{2,3}$/.test(w) && /^(pulgadas|pulgada|"|gb|tb|w|hz|mp)$/.test(next)) { out.push(w); return; }
      if (/^\d+(gb|tb|w|hz)$/.test(w)) { out.push(w); return; }
      if (w.length > 1 && STOP.indexOf(' ' + w + ' ') === -1 && !/^\d+$/.test(w) && w !== '€') out.push(w);
    });
    return out;
  }
  function specific(words) { return words.filter(function (w) { return GENERIC.indexOf(' ' + w + ' ') === -1 && !/^\d/.test(w); }); }

  function fetchMany(queries, opts) {
    return Promise.all(queries.map(function (q) { return fetchSearch(q, opts); })).then(function (all) {
      var seen = {};
      var out = [];
      all.forEach(function (r) { (r.products || []).forEach(function (p) { if (!seen[p.handle]) { seen[p.handle] = true; out.push(p); } }); });
      return { products: out };
    });
  }

  function fetchSearch(q, opts) {
    var p = new URLSearchParams();
    p.set('q', q);
    p.set('type', 'product');
    p.set('view', 'assistant');
    p.set('options[prefix]', 'last');
    p.set('filter.v.availability', '1');
    if (opts.type) p.set('filter.p.product_type', opts.type);
    if (opts.max) p.set('filter.v.price.lte', String(Math.round(opts.max)));
    if (opts.min) p.set('filter.v.price.gte', String(Math.round(opts.min)));
    return fetch('/search?' + p.toString(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.text() : '{"products":[]}'; })
      .then(function (txt) { try { return JSON.parse(txt); } catch (e) { return { products: [] }; } })
      .catch(function () { return { products: [] }; });
  }

  function searchUrl(q, opts) {
    var p = new URLSearchParams();
    p.set('q', q.replace(/"/g, ''));
    p.set('type', 'product');
    p.set('filter.v.availability', '1');
    if (opts.type) p.set('filter.p.product_type', opts.type);
    if (opts.max) p.set('filter.v.price.lte', String(Math.round(opts.max)));
    if (opts.min) p.set('filter.v.price.gte', String(Math.round(opts.min)));
    return '/search?' + p.toString();
  }

  function specScore(title) {
    var t = title.toLowerCase();
    var s = 0;
    var ram = t.match(/(\d{1,2})\s?gb(?!\s?(ssd|hdd|emmc))/);
    if (ram) s += Math.min(parseInt(ram[1], 10), 32) / 2;
    if (/i7|ryzen 7|ultra 7|ultra 5|i5|ryzen 5|core 5|core 7/.test(t)) s += 6;
    if (/i9|ryzen 9|ultra 9/.test(t)) s += 8;
    if (/ssd|nvme/.test(t)) s += 3;
    if (WEAK_PC.test(t)) s -= 12;
    return s;
  }

  function rank(products, ctx) {
    var words = ctx.words;
    return products
      .filter(function (p) {
        if (!p.available) return false;
        if (p.lote && !ctx.lotes) return false;
        if (!ctx.lotes && JUNK.test(p.title) && !ctx.parts) return false;
        if (ctx.lotes && !p.lote) return false;
        if (!ctx.parts && (/reparar|piezas|seg[uú]n descripci/i.test((p.state || '') + ' ' + (p.warranty || '')) || /pant(alla)?\.? ?rota|cristal roto|no funciona|no enciende|para reparar|o piezas/i.test(p.title))) return false;
        if (!ctx.parts && !/accesorio|recambio|repuesto/.test(ctx.words.join(' ')) && /^(accesorios? (para|de)|recambio|repuesto|kit de recambio)/i.test(p.title)) return false;
        if (!ctx.service && NOT_PHYSICAL.test(p.title)) return false;
        if (ctx.only && !ctx.only.test(p.title)) return false;
        if (ctx.use === 'gaming' && /mando a distancia|mando original para|para optoma|para proyector/i.test(p.title)) return false;
        if (ctx.use === 'gift' && (p.price < 20 || /sensor|riego|recambio|cable|adaptador|bater[ií]a|cargador|funda/i.test(p.title))) return false;
        if ((ctx.computer || ctx.type === 'Portátiles') && /^(mesa|silla|soporte|bandeja|funda|malet|mochila|cargador|bater|teclado|pantalla de repuesto|microsoft office)/i.test(p.title)) return false;
        if ((ctx.computer || ctx.type === 'Portátiles') && ctx.minSpec && specScore(p.title) < ctx.minSpec) return false;
        if (ctx.computer && !/sobremesa|\bpc\b|mini ?pc|ordenador|thinkcentre|optiplex|prodesk|elitedesk|veriton|aio|all in one|torre (hp|dell|lenovo|acer)|nuc/i.test(p.title)) return false;
        if (ctx.computer && /^(monitor|teclado|rat[oó]n|soporte|funda|cable|altavoces|micr[oó]fono|auricular|gamepad|mando|kit|disipador|webcam|peana|torre completa midi|torre multimedia)/i.test(p.title)) return false;
        return true;
      })
      .map(function (p) {
        var t = norm(p.title);
        var s = 0;
        words.forEach(function (w) { if (t.indexOf(w) !== -1) s += 4; });
        if (p.compare_at && p.compare_at > p.price) s += Math.min(6, ((p.compare_at - p.price) / p.compare_at) * 10);
        if (p.tara) s -= 2;
        if (ctx.type === 'Móviles' && ctx.use !== 'senior' && /b[aá]sico|teclas grandes|para mayores|\b2g\b|nokia 1\d\d|nokia 2\d\d|telefunken tm|kaios/i.test(p.title)) s -= 10;
        if (ctx.type === 'Imagen y TV' && /soporte|malet|mando|cable|sintonizador|adaptador|l[aá]mpara|m[oó]dulo|fuente de alimentaci|documentos|placa|repuesto|pantalla interactiva|se[nñ]alizaci/i.test(p.title)) s -= 15;
        if (ctx.use === 'gaming' || ctx.use === 'pro' || ctx.computer || ctx.type === 'Portátiles') s += specScore(p.title);
        return { p: p, s: s };
      })
      .sort(function (a, b) {
        if (ctx.cheap) return a.p.price - b.p.price || b.s - a.s;
        if (ctx.best) return b.s - a.s || b.p.price - a.p.price;
        return b.s - a.s || a.p.price - b.p.price;
      })
      .map(function (x) { return x.p; });
  }

  function dedupe(list) {
    var seen = {};
    return list.filter(function (p) {
      var k = norm(p.title).replace(/(negro|blanco|azul|rojo|rosa|gris|verde|plata|dorado|usad[oa]|nuevo|sin embalaje.*)$/g, '').slice(0, 48);
      if (seen[k]) return false;
      seen[k] = true;
      return true;
    });
  }

  function productSearch(text, t) {
    var budget = parseBudget(t);
    var cat = null;
    for (var i = 0; i < CATS.length; i++) { if (CATS[i].re.test(t)) { cat = CATS[i]; break; } }
    var use = null;
    for (var j = 0; j < USES.length; j++) { if (USES[j].re.test(t)) { use = USES[j]; break; } }
    var lotes = /\blote|lotes|al por mayor|mayorista|revender|reventa\b/.test(t);
    var parts = /pieza|piezas|repuesto|recambio|despiece/.test(t);

    // Refinar la búsqueda anterior ("más barato", "menos de 200", "otro", "más potente").
    var refine = last && !cat && !use && (budget.max || budget.min || budget.cheap || budget.best || /\b(otro|otros|otra|mas opciones|alguno mas|algo mas|y en|y de)\b/.test(t));
    var opts;
    if (refine) {
      opts = Object.assign({}, last, { max: budget.max || last.max, min: budget.min || last.min, cheap: budget.cheap || false, best: budget.best || false, page: (last.page || 0) + (/otro|otros|otra|mas opciones|alguno mas|algo mas/.test(t) ? 1 : 0) });
    } else {
      var words = keywords(t);
      if (use && use.id === 'gaming' && !cat) {
        if (/\b(ordenador|pc|sobremesa|torre|equipo)\b/.test(t)) cat = CATS[2];
        else if (/\bportatil/.test(t)) cat = CATS[1];
      }
      if (use && (use.id === 'study' || use.id === 'work' || use.id === 'pro') && !cat) cat = CATS[1];
      if (use && use.id === 'sport' && !cat) cat = CATS[9];
      if (use && use.id === 'senior' && !cat) cat = CATS[0];
      var spec = specific(words);
      var queries;
      var nums = words.filter(function (w) { return /^\d/.test(w); });
      if (spec.length) queries = [spec.concat(nums).join(' ') + (cat ? ' ' + cat.q : ''), spec.join(' ')];
      else if (cat && nums.length) queries = [cat.q + ' ' + nums.join(' ')].concat(cat.terms);
      else if (cat) queries = cat.terms;
      else if (use && use.id === 'gaming') queries = ['mando', 'volante', 'auriculares gaming', 'consola'];
      else if (use && use.id === 'gift') queries = ['polaroid', 'auriculares', 'reloj inteligente', 'robot', 'altavoz'];
      else if (lotes) queries = ['lote'];
      else queries = words.length ? [words.join(' ')] : [];
      var minSpec = 0;
      if (use && use.id === 'gaming' && cat && (cat.computer || cat.type === 'Portátiles')) minSpec = 10;
      else if (use && use.id === 'pro') minSpec = 12;
      else if (cat && (cat.computer || cat.type === 'Portátiles')) minSpec = 4;
      opts = { q: queries[0] || '', queries: queries, type: cat ? cat.type : null, only: cat ? cat.only : null, computer: cat ? !!cat.computer : false, label: cat ? cat.label : (lotes ? 'lotes' : null), use: use ? use.id : null, advice: use ? use.advice : null, words: spec.length ? spec : words, spec: spec, minSpec: minSpec, max: budget.max, min: budget.min, cheap: budget.cheap, best: budget.best, lotes: lotes, parts: parts, service: /servicio|garantia extendida|software|licencia|office/.test(t), page: 0 };
    }
    if (!opts.q) return Promise.resolve(null);
    last = opts;

    var qs = opts.queries && opts.queries.length ? opts.queries : [opts.q];
    return fetchMany(qs, opts).then(function (res) {
      var list = rank(res.products || [], opts);
      if (!list.length && opts.type) {
        return fetchMany(qs, Object.assign({}, opts, { type: null })).then(function (r2) { return { list: rank(r2.products || [], Object.assign({}, opts, { type: null })), relaxed: 'type' }; });
      }
      return { list: list };
    }).then(function (r) {
      if (!r.list.length && (opts.max || opts.min)) {
        return fetchMany(qs, Object.assign({}, opts, { max: null, min: null })).then(function (r3) { return { list: rank(r3.products || [], opts), relaxed: 'price' }; });
      }
      return r;
    }).then(function (r) {
      var list = dedupe(r.list);
      var start = (opts.page || 0) * 4;
      var shown = list.slice(start, start + 4);
      if (!shown.length && list.length) { shown = list.slice(0, 4); opts.page = 0; }
      var url = searchUrl(opts.q, opts);
      if (!shown.length) return null;
      var intro = '';
      var missing = (opts.spec || []).filter(function (w) { return w.length > 2 && !shown.some(function (p) { return norm(p.title).indexOf(w) !== -1; }); });
      if (missing.length && !refine) intro += 'Ahora mismo no tengo «' + esc(missing.join(' ')) + '» exacto. Te enseño lo más parecido que hay (el stock cambia cada semana, pregúntame más adelante o ' + link('/pages/contact', 'escríbenos') + ' y te avisamos):<br><br>';
      var adviceFits = !(opts.use === 'gaming' && opts.type && opts.type !== 'Portátiles' && !opts.computer);
      if (opts.advice && !refine && adviceFits) intro += esc(opts.advice) + '<br><br>';
      var what = opts.label ? opts.label : 'productos';
      if (r.relaxed === 'price') {
        intro += 'No tengo ' + esc(what) + (opts.max ? ' por debajo de ' + money(opts.max) : '') + ' ahora mismo. Esto es lo más cercano:';
      } else if (opts.cheap) {
        intro += 'Lo más económico en ' + esc(what) + (opts.max ? ' hasta ' + money(opts.max) : '') + ':';
      } else {
        intro += 'Te recomiendo estos ' + esc(what) + (opts.max ? ' hasta ' + money(opts.max) : '') + (opts.min ? ' desde ' + money(opts.min) : '') + ':';
      }
      var outro = '<br><br>' + link(url, 'Ver todos los resultados') + (list.length > start + 4 ? ' · o dime "otros" y te enseño más.' : '');
      outro += ' ¿Tienes un presupuesto o algo concreto en mente? Dímelo y afino.';
      return { html: intro, products: shown.map(toCard), after: outro };
    });
  }

  function toCard(p) {
    return { url: p.url, title: p.title, price: p.price, image: p.image, state: (p.state || p.estado || '') + (p.warranty ? ' · ' + p.warranty : '') };
  }

  // ---------- Preguntas frecuentes ----------
  function faq(t, current) {
    if (/^(hola|buenas|buenos dias|buenas tardes|buenas noches|hey|holi|saludos)\b/.test(t) && t.split(' ').length <= 4) {
      return { html: '¡Hola! Soy el asistente de Tecno Restore. Dime qué buscas (por ejemplo, "un portátil para estudiar por menos de 400 €" o "un PC para jugar a Roblox") o pregúntame lo que quieras sobre envíos, garantía o devoluciones.' };
    }
    if (/^(gracias|muchas gracias|vale gracias|perfecto|genial|ok|vale)\b/.test(t) && t.split(' ').length <= 4) {
      return { html: '¡A ti! Si necesitas algo más, aquí estoy. ' + contactLine };
    }
    if (/(que (es|significa|quiere decir)|diferencia|diferencias|explica|como de)/.test(t) && /(exposicion|reacondicionad|devolucion revisada|como nuevo|excedente|con tara|tara|grado|estado|estados|usado|liquidacion)/.test(t) || /\b(estado(s)? de los productos|son nuevos|es nuevo|esta nuevo|de segunda mano)\b/.test(t)) {
      return { html: 'Cada ficha dice el estado real de la unidad:<br>• <strong>Nuevo · Precintado</strong>: con su precinto de fábrica. 3 años de garantía legal.<br>• <strong>Como nuevo</strong>: en perfectas condiciones, sin precinto de fábrica (liquidación o excedente de stock). 1 año de garantía.<br>• <strong>Exposición</strong>: unidad que ha estado en tienda o exposición. 1 año.<br>• <strong>Reacondicionado</strong>: revisado y puesto a punto. 1 año.<br>• <strong>Devolución revisada / Usado</strong>: lo devolvió otro cliente o tiene uso, y lo hemos comprobado. 1 año.<br>• <strong>Con tara</strong>: tiene un golpe, marca o fallo que se indica en la ficha; por eso es más barato. 1 año.' };
    }
    if (/\b(envio|envios|enviais|envian|mandais|llega|llegara|tarda|tardan|tardais|plazo|entrega|transport|seur|correos|gls|mrw|mensajero)\b/.test(t) || /canarias|baleares|mallorca|menorca|ibiza|formentera|tenerife|gran canaria|lanzarote|fuerteventura|la palma|ceuta|melilla|portugal|andorra|francia|extranjero|fuera de espana|internacional/.test(t)) {
      var islands = /canarias|baleares|mallorca|menorca|ibiza|formentera|tenerife|gran canaria|lanzarote|fuerteventura|la palma|ceuta|melilla|portugal|andorra|francia|extranjero|fuera de espana|internacional/.test(t);
      return { html: 'El <strong>envío es gratis en pedidos a partir de 50 €</strong> (por debajo cuesta 5,95 €) y llega en <strong>24–72 h laborables</strong> en la península (con SEUR, Correos Express, GLS o MRW). En la ficha de cada producto verás la fecha estimada de entrega.' + (islands ? '<br><br>Para Baleares, Canarias, Ceuta, Melilla o fuera de España, escríbenos antes de comprar y te confirmamos plazo y coste. ' + contactLine : '') };
    }
    if (/\b(devol|devolver|devuelvo|devolverlo|cambiar|cambio|desistimiento|reembolso|reembolsar|arrepiento|arrepentido|no me gusta|no me convence)/.test(t)) {
      return { html: 'Tienes <strong>' + (C.return_days || 30) + ' días</strong> desde que lo recibes para devolverlo (además de los 14 días de desistimiento que marca la ley). Escríbenos con tu número de pedido y te indicamos cómo enviarlo. Los lotes y las ventas B2B tienen sus propias condiciones. ' + link('/policies/refund-policy', 'Ver la política de devoluciones') + '.' };
    }
    if (/\b(garantia|garantias|averia|se rompe|se estropea|falla|fallo|defecto|defectuoso|reparar|reparacion|no funciona|no enciende)\b/.test(t)) {
      if (current) {
        return { html: 'Este producto (<strong>' + esc(current.title) + '</strong>) es <strong>' + esc(current.state) + '</strong> y tiene <strong>' + esc(current.warranty) + '</strong>.' + (current.note ? ' Detalle de la unidad: ' + esc(current.note) + '.' : '') + ' Si te da cualquier problema, escríbenos y lo reparamos o lo sustituimos.', products: [toCard(current)] };
      }
      return { html: 'La garantía depende del estado de la unidad, y siempre la verás en la ficha:<br>• <strong>Nuevo precintado</strong>: <strong>3 años</strong> de garantía legal.<br>• <strong>Como nuevo, exposición, reacondicionado, devolución, usado o con tara</strong>: <strong>1 año</strong>.<br>Si algo falla, te lo reparamos o sustituimos sin coste. ' + contactLine };
    }
    if (/\b(pagar|pago|pagos|tarjeta|visa|mastercard|paypal|bizum|transferencia|plazos|financiar|financiacion|klarna|apple pay|google pay|contrareembolso|contra reembolso|efectivo)\b/.test(t)) {
      var methods = (cfg.payments && cfg.payments.length) ? cfg.payments.join(', ') : 'tarjeta, Apple Pay, Google Pay y PayPal';
      var extra = /bizum|transferencia|contrareembolso|contra reembolso|efectivo/.test(t) ? ' Ahora mismo no aceptamos Bizum, transferencia ni contrarreembolso.' : '';
      var klarna = /plazos|financ|klarna/.test(t) ? ((cfg.payments || []).join(' ').toLowerCase().indexOf('klarna') !== -1 ? ' Con Klarna puedes pagar a plazos: elígelo al finalizar la compra.' : ' Ahora mismo no ofrecemos pago a plazos.') : '';
      return { html: 'Puedes pagar con: <strong>' + esc(methods) + '</strong>. El pago es seguro y lo procesa Shopify: nunca vemos los datos de tu tarjeta.' + extra + klarna };
    }
    if (/\b(factura|facturas|iva|cif|nif|empresa|autonomo|sociedad|deducir)\b/.test(t)) {
      return { html: 'Sí, emitimos <strong>factura con IVA</strong>. Tras la compra, escríbenos a <strong>' + EMAIL + '</strong> con tu número de pedido y tus datos fiscales (nombre o razón social, NIF/CIF y dirección) y te la enviamos. Si compras con frecuencia o en volumen, mira ' + link(C.pro_url || '/pages/tecno-restore-pro', 'Tecno Restore PRO') + '.' };
    }
    if (/\b(mi pedido|pedido|seguimiento|tracking|numero de envio|donde esta|no me ha llegado|no ha llegado|no llega|cuando me llega|estado del pedido)\b/.test(t)) {
      return { html: 'Cuando enviamos tu pedido te llega un correo con el <strong>número de seguimiento</strong>. Si no lo encuentras (mira también en spam) o tu pedido se retrasa, escríbenos a <strong>' + EMAIL + '</strong> con el número de pedido y lo miramos al momento. También puedes llamarnos al <strong>' + PHONE + '</strong> (' + HOURS + ').' };
    }
    if (/\b(contacto|contactar|telefono|llamar|llamaros|whatsapp|email|correo|hablar con|persona|humano|alguien|atencion al cliente|horario|abris|abierto)\b/.test(t)) {
      return { html: contactLine + ' También puedes usar el ' + link('/pages/contact', 'formulario de contacto') + '.' };
    }
    if (/\b(tienda fisica|recoger|recogida|en mano|donde estais|direccion|visitar|ir a veros|ubicacion|local|almacen)\b/.test(t)) {
      return { html: 'Somos una tienda online (Barcelona) y enviamos a toda la península, gratis a partir de 50 €. Si prefieres recoger en mano, escríbenos y lo vemos. ' + contactLine };
    }
    if (/\b(descuento|cupon|codigo|rebaja|negociar|regatear|mejor precio|precio final|me lo dejas)\b/.test(t)) {
      return { html: 'Los precios ya son de outlet y no usamos códigos de descuento. Para enterarte antes que nadie de lo que entra nuevo, apúntate a la newsletter al final de la página. Si compras varias unidades, mira ' + link(C.pro_url || '/pages/tecno-restore-pro', 'Tecno Restore PRO') + '.' };
    }
    if (/\b(fiable|fiar|confianza|estafa|timo|seguro comprar|es seguro|es real|de verdad|legal|garantias reales)\b/.test(t)) {
      return { html: 'Puedes comprar tranquilo: el pago lo procesa Shopify (nunca vemos tu tarjeta), cada ficha dice el estado real de la unidad, tienes garantía y <strong>' + (C.return_days || 30) + ' días</strong> para devolverlo. Y detrás hay personas: ' + contactLine };
    }
    if (/\b(caja|embalaje|precinto|precintado|accesorios|que incluye|viene con|trae|incluido|incluida|cargador incluido|manual)\b/.test(t)) {
      return { html: 'Lo que incluye cada unidad está en su ficha (en "Qué incluye la caja" o en la descripción), igual que si viene sin embalaje original o con la caja abierta.' + (current ? ' En este producto: <strong>' + esc(current.state) + '</strong>' + (current.note ? ' · ' + esc(current.note) : '') + '.' : '') + ' Si tienes una duda concreta, ' + contactLine };
    }
    if (current && /\b(compatible|compatibilidad|sirve para|funciona con|especificaciones|caracteristicas|ram|bateria|pantalla|medidas|peso|tamano|procesador|windows|idioma|teclado|color)\b/.test(t)) {
      return { html: 'Las especificaciones completas de <strong>' + esc(current.title) + '</strong> están en la ficha, en la pestaña "Descripción". Si no encuentras lo que buscas, ' + contactLine, products: [toCard(current)] };
    }
    if (/\b(pro|profesional|profesionales|revendedor|tienda de reparacion|mayorista)\b/.test(t) && !/\b(portatil|movil|tablet)\b/.test(t)) {
      return { html: 'Para profesionales y revendedores tenemos ' + link(C.pro_url || '/pages/tecno-restore-pro', 'Tecno Restore PRO') + ' (acceso anticipado, varias unidades del mismo modelo y trato directo) y ' + link(C.lotes_url || '/collections/venta-por-lotes', 'venta por lotes') + '.' };
    }
    return null;
  }

  function currentProduct() {
    if (!cfg.currentHandle) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(cfg.currentHandle) + '?view=assistant')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  // Preguntas sobre el producto que el cliente está viendo.
  function aboutCurrent(t, cur) {
    var isComputer = /sobremesa|\bpc\b|mini ?pc|ordenador|port[aá]til|thinkcentre|optiplex|elitebook|probook|latitude|thinkpad|vostro|aio|chromebook/i.test(cur.title);
    var use = null;
    for (var j = 0; j < USES.length; j++) { if (USES[j].re.test(t)) { use = USES[j]; break; } }
    if (/\b(sirve|vale|aguanta|puedo|va bien|funciona bien|me vale)\b/.test(t) && use && isComputer) {
      var sc = specScore(cur.title);
      var verdict;
      if (use.id === 'gaming') verdict = sc >= 10 ? 'Sí. Con sus características va fluido en Roblox, Minecraft o Fortnite. Para juegos muy exigentes (los últimos de PC en calidad alta) se quedaría corto, porque no lleva tarjeta gráfica dedicada.' : 'Para juegos ligeros como Roblox podría servir, pero va justo: lo ideal es un Intel Core i5 o Ryzen 5 con 8 GB de RAM y SSD.';
      else if (use.id === 'pro') verdict = sc >= 14 ? 'Sí, tiene potencia suficiente para editar o programar con soltura.' : 'Para tareas ligeras sí; para editar vídeo con soltura conviene un i7 / Ryzen 7 con 16 GB de RAM.';
      else verdict = sc >= 7 ? 'Sí, va sobrado para eso.' : 'Para tareas básicas sí, aunque no es de los más rápidos.';
      return { html: '<strong>' + esc(cur.title) + '</strong>: ' + verdict + ' ¿Quieres que te enseñe alternativas parecidas?', products: [toCard(cur)] };
    }
    if (/\b(parecido|parecida|similar|similares|alternativa|alternativas|otro como|mas barato|mas barata|mas economico|mas potente|mejor que este)\b/.test(t)) {
      var cheaper = /mas barat|mas economic/.test(t);
      var better = /mas potente|mejor que/.test(t);
      var key = norm(cur.title).split(' ').filter(function (w) { return w.length > 2 && !/^\d/.test(w); }).slice(0, 2).join(' ');
      var qs = [cur.type ? (cur.type === 'Portátiles' ? 'portátil' : cur.type === 'Informática y Periféricos' && isComputer ? 'sobremesa' : key) : key];
      if (isComputer && cur.type !== 'Portátiles') qs = ['sobremesa', 'mini pc', 'ordenador'];
      var opts = { type: cur.type || null, max: cheaper ? cur.price - 1 : null, min: better ? cur.price : null };
      var ctx = { words: [], computer: isComputer && cur.type !== 'Portátiles', type: cur.type, minSpec: isComputer ? 4 : 0, cheap: cheaper, best: better };
      last = { q: qs[0], queries: qs, type: opts.type, max: opts.max, min: opts.min, computer: ctx.computer, words: [], spec: [], minSpec: ctx.minSpec, label: null, page: 0 };
      return fetchMany(qs, opts).then(function (r) {
        var list = dedupe(rank(r.products || [], ctx).filter(function (p) { return p.handle !== cur.handle; })).slice(0, 4);
        if (!list.length) return { html: 'Ahora mismo no tengo nada parecido ' + (cheaper ? 'más barato' : '') + ' a <strong>' + esc(cur.title) + '</strong>. El stock cambia cada semana: ' + contactLine };
        return { html: (cheaper ? 'Alternativas más baratas que este (' + money(cur.price) + '):' : better ? 'Alternativas con más potencia:' : 'Alternativas parecidas a este:'), products: list.map(toCard) };
      });
    }
    if (/\b(incluye|trae|viene con|lleva|caja|accesorios|cargador|teclado y raton|mando)\b/.test(t)) {
      return { html: 'En <strong>' + esc(cur.title) + '</strong>: estado <strong>' + esc(cur.state) + '</strong>' + (cur.note ? ', ' + esc(cur.note) : '') + '. Lo que incluye viene en la ficha, en "Qué incluye la caja" o en la descripción. Si no lo ves claro, escríbenos y te lo confirmamos mirando la unidad: ' + contactLine, products: [toCard(cur)] };
    }
    return null;
  }

  function fallback(text) {
    var q = keywords(norm(text)).join(' ');
    return { html: 'No he encontrado nada que encaje con eso ahora mismo. ' + (q ? link('/search?q=' + encodeURIComponent(q) + '&type=product', 'Buscar "' + q + '" en la tienda') + ' · ' : '') + 'Entra mercancía nueva cada semana: si me dices marca y modelo, o para qué lo quieres y tu presupuesto, te busco alternativas. ' + contactLine };
  }

  function answer(text) {
    var t = norm(text);
    var needsCurrent = cfg.currentHandle && /\b(este|esta|esto|ese|esa|el producto|la unidad|garantia|incluye|trae|viene|lleva|compatible|especificaciones|caja|estado|sirve|vale|aguanta|puedo|parecido|similar|alternativa|mas barato|mas barata|otro como)\b/.test(t);
    return (needsCurrent ? currentProduct() : Promise.resolve(null)).then(function (current) {
      if (current) {
        var c = aboutCurrent(t, current);
        if (c) return c;
      }
      var f = faq(t, current);
      if (f) return f;
      return productSearch(text, t).then(function (r) { return r || fallback(text); });
    });
  }

  return { answer: answer, reset: function () { last = null; } };
}
